/* Crystal Quest water softener size calculator: page script for sections/cq-softener-size.liquid.
 *
 * Reads the inputs, runs window.CQSoftenerSizing (assets/cq-softener-sizing.js) on every change and draws the result:
 * the navy result pane (size, the math behind it, product drawer with live price and Add to cart), the notes row,
 * every size side by side, the sizing chart (which follows the visitor's bathrooms) and the phone result bar.
 * v3 (2026-10-15, Brain project softener-size-calculator-2026-10, working/redesign-v3/research/G4-build-spec.md): a
 * guided first run. The calculator block opens as one question per screen in the family quiz look (the screens live
 * once, in the section's <template data-cqss-screens>), plays a short sizing moment built from the visitor's own
 * numbers, then shows the result and becomes this live calculator. The form and `state` stay the only home of every
 * answer: guided screens write through the setters the form uses (setSeg, setFlag, setSign, setField) and paint from
 * `state`. One codec (encodeState, decodeState) feeds the share URL and the tab's sessionStorage ("cqss:v3"); guided
 * steps never touch history. The section's pre-paint script paints the first or stored screen before first paint and
 * records a tap made before this file runs; data-cqss-live is set only at the end of a good boot, and any failure
 * calls the section's cqssFallback(), which returns the full form.
 * v2 (2026-10-15): nodes are updated in place instead of rebuilt, so every transition runs: segmented controls get a
 * sliding thumb, steps and answers open smoothly, numbers roll, cards settle with FLIP, lower sections reveal on
 * scroll. Every motion reads prefers-reduced-motion live and snaps when it is set (Brain project
 * softener-size-calculator-2026-10, working/redesign-v2/research/R2-motion.md).
 * Products and prices come from the section's live catalogue (product pickers), never from this file. Add to cart
 * posts /cart/add.js and opens the side cart; Configure opens the store's own Configure dialog
 * (data-cq-choose-options, assets/quick-view-options.js). The specialist form posts the visitor-reviewed summary to
 * HubSpot form F1 (Help Desk) and falls back to the Shopify contact form. Analytics are Shopify customer events named
 * cq_quiz_* with IDs and bands only, never typed numbers or a ZIP. No em or en dashes in any text.
 */
(function () {
  'use strict';
  const root = document.getElementById('cq-softsize');
  if (!root || root.dataset.cqssBooted) return;
  root.dataset.cqssBooted = '1';
  // G4 14 item 5: anything that stops a good boot hands the page back as the full form (the section's pre-paint script
  // defines cqssFallback; without it, the guided attributes are simply removed)
  const fail = () => {
    try { document.documentElement.classList.remove('cqss-fs', 'cqss-fs-scroll'); } catch (_) { /* no classList */ }
    try { if (typeof window.cqssFallback === 'function') window.cqssFallback(); else { root.removeAttribute('data-cqss-mode'); root.removeAttribute('data-cqss-step'); } } catch (_) { /* nothing more to do */ }
  };
  const S = window.CQSoftenerSizing;
  if (!S) { fail(); return; }
  try { main(); } catch (err) {
    fail();
    try { window.console.error('[cqss] boot failed', err); } catch (_) { /* no console */ }
  }

  function main() {
  const $ = (sel, el) => (el || root).querySelector(sel);
  const $$ = (sel, el) => Array.from((el || root).querySelectorAll(sel));
  const form = $('[data-cqss-form]');
  const mqCalm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  // read live, not once: reduced motion, Save-Data where the browser reports it (not on iOS), or a paused-motion
  // ancestor (family cq-well-v3-quiz.js:373 to 374)
  const calm = () => !!((mqCalm && mqCalm.matches) || root.closest('[data-cqv-motion-paused]') ||
    (navigator.connection && navigator.connection.saveData));
  const GLIDE = 'cubic-bezier(.22,.9,.24,1)', EASE = 'cubic-bezier(.22,.61,.36,1)';
  const later = (fn, ms) => window.setTimeout(fn, ms);
  const reflow = el => el.getBoundingClientRect();            // commits a style before a transition starts
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));
  const fmt = n => n == null ? '' : Math.round(n).toLocaleString('en-US');
  const fmt1 = n => n == null ? '' : (Math.round(n * 10) / 10).toLocaleString('en-US');
  const trimNum = n => n == null || !isFinite(n) ? '' : (Math.round(n * 100) / 100).toLocaleString('en-US');   // a typed figure, as typed
  let catalog = {};
  try { catalog = JSON.parse($('script[data-cqss-catalog]').textContent || '{}'); } catch (_) { catalog = {}; }
  const currency = root.dataset.currency || 'USD';
  const money = cents => { try { return new Intl.NumberFormat('en-US', {style: 'currency', currency, maximumFractionDigits: cents % 100 ? 2 : 0}).format(cents / 100); } catch (_) { return '$' + (cents / 100).toFixed(2); } };
  const QUIZ = 'softener-size';
  const track = (name, payload) => {
    const p = Object.assign({quiz: QUIZ}, payload || {});
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, p); } catch (_) { /* analytics never blocks the tool */ }
    try { root.dispatchEvent(new CustomEvent('cqq:event', {bubbles: true, detail: {name, payload: p}})); } catch (_) { /* old browsers */ }
  };
  // only animates when the text really changes
  function setText(el, text, quiet) {
    if (!el || el.textContent === String(text)) return;
    el.textContent = text;
    if (quiet || calm()) return;
    el.classList.remove('cqss-swap'); void el.offsetWidth; el.classList.add('cqss-swap');
  }

  /* Family ports (assets/cq-well-v3-quiz.js, 2026-10-15). cssTimeMs, js:954 to 959: Shopify may serialize 650ms as .65s,
     so every timer read from a CSS token goes through it. */
  function cssTimeMs(value, fallback) {
    const match = String(value == null ? '' : value).trim().match(/^(\d*\.?\d+)(ms|s)?$/i);
    if (!match) return fallback;
    const ms = Number(match[1]) * (match[2] && match[2].toLowerCase() === 's' ? 1000 : 1);
    return Number.isFinite(ms) ? ms : fallback;
  }
  /* Word reveal, js:1103 to 1155 (revealWords), one element at a time: each word rises in turn on the CSS timing tokens
     (--cqq-word-ms, --cqq-word-step, capped by --cqq-word-span); a hidden copy carries the whole text for screen
     readers and the visual pieces are aria-hidden. The wrappers stay for the element's lifetime (unwrapping changed
     kerning). `offset` delays the start by that many steps. Returns the total time, 0 when nothing animates. */
  let wordUndo = [];
  function finishWords() { const list = wordUndo; wordUndo = []; list.forEach(fn => { try { fn(); } catch (_) { /* gone */ } }); }
  function words(h, offset) {
    if (!h || !h.isConnected || calm() || h.querySelector('a, button, input, select, textarea, .cqq-words-sr')) return 0;
    const units = [];
    const sr = document.createElement('span'); sr.className = 'cqv-sr-only cqq-words-sr';
    const textOf = el => Array.from(el.childNodes).map(n => {
      if (n.nodeType === 3) return n.textContent;
      if (n.nodeType !== 1) return '';
      if (n.matches('br')) return ' ';
      const disp = window.getComputedStyle(n).display;
      if (disp === 'none') return '';
      return /^(inline|inline-block|contents)$/.test(disp) ? textOf(n) : ' ' + textOf(n) + ' ';
    }).join('');
    sr.textContent = textOf(h).replace(/\s+/g, ' ').trim();
    const walk = node => Array.from(node.childNodes).forEach(n => {
      if (n.nodeType === 3) {
        const parts = n.textContent.split(/([ \t\n\r\f]+)/);
        if (!parts.some(p => p && !/^[ \t\n\r\f]+$/.test(p))) return;
        const frag = document.createDocumentFragment();
        parts.forEach(p => {
          if (!p) return;
          if (/^[ \t\n\r\f]+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
          const w = document.createElement('span'); w.className = 'cqq-w'; w.setAttribute('aria-hidden', 'true'); w.textContent = p;
          frag.appendChild(w); units.push(w);
        });
        n.replaceWith(frag);
      } else if (n.nodeType === 1 && !n.hidden) walk(n);
    });
    walk(h);
    if (!units.length) return 0;
    h.insertBefore(sr, h.firstChild);
    h.classList.remove('cqq-words-done');
    h.classList.add('cqq-words');
    const motion = window.getComputedStyle(h);
    const step = Math.min(cssTimeMs(motion.getPropertyValue('--cqq-word-step'), 110), Math.floor(cssTimeMs(motion.getPropertyValue('--cqq-word-span'), 700) / Math.max(1, units.length - 1)));
    units.forEach((u, i) => u.style.setProperty('--cqq-wi', String(i + (offset || 0))));
    h.style.setProperty('--cqq-word-step', step + 'ms');
    const total = cssTimeMs(motion.getPropertyValue('--cqq-word-ms'), 650) + step * Math.max(0, units.length - 1 + (offset || 0));
    let done = false;
    const finish = () => { if (done) return; done = true; h.classList.add('cqq-words-done'); };
    wordUndo.push(finish);
    later(() => { wordUndo = wordUndo.filter(fn => fn !== finish); finish(); }, total + 40);
    return total;
  }
  // a short sideways shake on a primary that is not ready yet (family cqq-nudge); the message alone when calm
  function nudge(el) {
    if (!el || calm()) return;
    el.classList.remove('cqq-nudge'); void el.offsetWidth; el.classList.add('cqq-nudge');
    later(() => el.classList.remove('cqq-nudge'), 360);
  }

  /* ------------------------------------------------------------------ state */
  const state = {
    hardness: '', unit: 'gpg', hardSource: null, useEstimate: false, source: null, people: 4, baths: 2, bathStyle: 'combo',
    hose: false, extraHeads: 0, wfh: false, iron: '', manganese: '', ph: '', nitrate: '', tds: '', alkalinity: '',
    signs: [], usePreset: 'typical', billGallons: '', pumpGpm: '', regenerant: 'salt', septic: false, preference: 'balanced',
    choice: null, setup: null, basis: root.dataset.basis === 'rated' ? 'rated' : 'independent'
  };
  let result = null;
  let started = false;

  /* ------------------------------------------------------------------ motion helpers */
  /* Segmented thumb: one navy pill per .cqss-seg that glides to the chosen option. It watches aria-pressed,
     aria-checked and aria-selected, so setPressed(), the URL restore, the chart tabs and arrow keys all move it.
     Each seg's place() is kept so placeAll() can set every thumb at once after a hidden form is shown (G4 9.1). */
  const places = new WeakMap();
  function placeAll(container) { $$('.cqss-seg', container).forEach(seg => { const p = places.get(seg); if (p) p(true); }); }
  function mountThumb(seg) {
    if (!seg || seg.querySelector(':scope > .cqss-seg-thumb')) return;
    const thumb = document.createElement('span');
    thumb.className = 'cqss-seg-thumb';
    thumb.setAttribute('aria-hidden', 'true');
    seg.prepend(thumb);
    seg.classList.add('has-thumb');
    const place = snap => {
      const on = seg.querySelector(':scope > button[aria-pressed="true"], :scope > button[aria-checked="true"], :scope > button[aria-selected="true"]');
      if (!on || !on.offsetWidth) { thumb.classList.remove('is-on'); return; }
      const appear = !thumb.classList.contains('is-on');
      if (snap || appear || calm()) seg.classList.add('is-snap');
      seg.style.setProperty('--th-x', on.offsetLeft + 'px');
      seg.style.setProperty('--th-y', on.offsetTop + 'px');
      seg.style.setProperty('--th-w', on.offsetWidth + 'px');
      seg.style.setProperty('--th-h', on.offsetHeight + 'px');
      if (seg.classList.contains('is-snap')) { reflow(thumb); seg.classList.remove('is-snap'); }
      thumb.classList.add('is-on');
    };
    places.set(seg, place);
    place(true);
    new MutationObserver(() => place(false)).observe(seg, {subtree: true, attributes: true, attributeFilter: ['aria-pressed', 'aria-checked', 'aria-selected']});
    if ('ResizeObserver' in window) {
      let primed = false;   // the first callback only reports the initial sizes; skip it so a fast first click still glides
      const ro = new ResizeObserver(() => { if (primed) place(true); primed = true; });
      ro.observe(seg); $$(':scope > button', seg).forEach(b => ro.observe(b));
    }
  }

  /* Smooth <details>: a height tween on the body, the content fades in a beat later; reverses mid-flight.
     Steps, card specs (which open and close together across the row) and the FAQ all use it. */
  const accordion = (() => {
    const running = new WeakMap();
    const bodyOf = d => d.querySelector(':scope > .cqss-more-body') || d.querySelector(':scope > div');
    function run(d, opening) {
      const body = bodyOf(d);
      if (!body || calm()) { d.open = opening; d.classList.remove('is-closing'); return; }
      // a closed <details> must read 0: Chromium lays out the hidden content on demand and reports its full height
      const from = d.open && !d.classList.contains('is-closing') ? body.getBoundingClientRect().height : (d.open ? body.getBoundingClientRect().height : 0);
      const prev = running.get(d); if (prev) prev.forEach(a => a.cancel());
      if (opening) { d.classList.remove('is-closing'); d.open = true; } else d.classList.add('is-closing');
      const to = opening ? body.scrollHeight : 0;
      const h = body.animate([{height: from + 'px'}, {height: to + 'px'}], {duration: opening ? 320 : 240, easing: opening ? 'cubic-bezier(.22,.9,.24,1)' : 'cubic-bezier(.4,0,1,1)'});
      const o = body.animate(opening ? [{opacity: 0, transform: 'translateY(-4px)'}, {opacity: 1, transform: 'none'}] : [{opacity: 1}, {opacity: 0}],
        opening ? {duration: 240, delay: 60, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'backwards'} : {duration: 140, easing: 'linear', fill: 'forwards'});
      running.set(d, [h, o]);
      h.finished.then(() => { running.delete(d); o.cancel(); if (!opening) { d.open = false; d.classList.remove('is-closing'); } }).catch(() => {});
    }
    const isOpen = d => d.open && !d.classList.contains('is-closing');
    root.addEventListener('click', e => {
      const s = e.target.closest('summary');
      if (!s || !root.contains(s)) return;
      const d = s.parentElement;
      if (!d || !d.matches('details.cqss-more, details.cqss-workings, .cqss-faq details, .cqss-card-specs')) return;
      e.preventDefault();
      const opening = !isOpen(d);
      if (d.matches('.cqss-card-specs')) { $$('.cqss-card-specs', cardsEl).forEach(x => { if (isOpen(x) !== opening) run(x, opening); }); track('cq_quiz_answer', {screen: 'card-specs', value: opening ? 'open' : 'close'}); }
      else run(d, opening);
    });
    // open(d, true) opens at once (the reveal opens Fine-tune instantly when it holds a value, G4 9.1)
    return {
      open: (d, instant) => { if (!d || isOpen(d)) return; if (instant) { d.open = true; d.classList.remove('is-closing'); } else run(d, true); },
      close: (d, instant) => { if (!d || !d.open) return; if (instant) { d.open = false; d.classList.remove('is-closing'); } else if (isOpen(d)) run(d, false); }
    };
  })();

  /* How to size (AJ 10-15 item 9): on desktop the steps light up in turn as the page scrolls and the sticky photo beside
     them changes to that step's real photo. Only opacity changes, so nothing moves. Phones show each step's own photo
     above it and nothing is driven. */
  (() => {
    const how = $('#cqss-how .cqss-how');
    if (!how) return;
    const steps = $$('.cqss-steps > li', how), shots = $$('[data-cqss-shot]', how);
    if (!steps.length || shots.length !== steps.length) return;
    const wide = window.matchMedia('(min-width: 901px)');
    let at = -1, frame = 0;
    const set = i => { if (i === at) return; at = i; steps.forEach((s, k) => s.classList.toggle('is-on', k === i)); shots.forEach((s, k) => s.classList.toggle('is-on', k === i)); };
    const pick = () => { frame = 0; if (!wide.matches) return; const line = window.innerHeight * 0.55; let i = 0; steps.forEach((s, k) => { if (s.getBoundingClientRect().top < line) i = k; }); set(i); };
    const soon = () => { if (!frame) frame = requestAnimationFrame(pick); };
    how.classList.add('is-driven');
    set(0);
    window.addEventListener('scroll', soon, {passive: true});
    window.addEventListener('resize', soon);
    if (wide.addEventListener) wide.addEventListener('change', soon);
    pick();
  })();

  /* "?" popovers (a size card's specs and math): small, anchored under their button, one open at a time. A second
     press, Escape or a press anywhere else closes it; Escape hands focus back to the button. */
  const pops = (() => {
    let open = null;
    const close = back => {
      if (!open) return;
      const o = open; open = null;
      o.pop.hidden = true; o.btn.setAttribute('aria-expanded', 'false');
      if (back && o.btn.isConnected) o.btn.focus();
    };
    document.addEventListener('click', e => {
      const b = e.target.closest('[data-cqss-pop]');
      if (b && root.contains(b)) {
        const again = open && open.btn === b;
        close();
        if (again) return;
        const pop = b.nextElementSibling;
        if (!pop) return;
        pop.hidden = false; b.setAttribute('aria-expanded', 'true'); open = {btn: b, pop};
        const q = b.querySelector('.cqss-q') || b, qr = q.getBoundingClientRect(), pr = pop.getBoundingClientRect();
        pop.style.setProperty('--ax', Math.round(qr.left + qr.width / 2 - pr.left - 6) + 'px');
        if (!calm()) pop.animate([{opacity: 0, transform: 'translateY(-4px) scale(.98)'}, {opacity: 1, transform: 'none'}], {duration: 180, easing: 'cubic-bezier(.22,.61,.36,1)'});
        track('cq_quiz_answer', {screen: 'card-specs', value: 'open'});
        return;
      }
      if (open && (!open.pop.contains(e.target) || e.target.closest('a'))) close();
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && open) close(true); });
    return {close};
  })();

  /* Width-stable, interruptible number roll: the final value keeps the box size, a live layer counts on top. */
  const rolls = new WeakMap();
  function roll(el, to) {
    if (!el) return;
    const fin = el.firstElementChild, live = el.lastElementChild;
    const prev = rolls.get(el);
    const from = prev ? prev.value : to;
    if (prev) cancelAnimationFrame(prev.raf);
    fin.textContent = fmt(to);
    if (calm() || from === to || !prev) { el.classList.remove('is-rolling'); rolls.set(el, {value: to, raf: 0}); return; }
    // the count starts on the first painted frame, from where it stands (a clock read before the frame could put the
    // first frame before the start and send the number the wrong way, AJ 10-16)
    live.textContent = fmt(from);
    el.classList.add('is-rolling');
    const dur = 420;
    let t0 = 0;
    const st = {value: from, raf: 0}; rolls.set(el, st);
    const step = t => {
      if (!t0) t0 = t;
      const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 4);
      st.value = from + (to - from) * e; live.textContent = fmt(st.value);
      if (k < 1) st.raf = requestAnimationFrame(step); else { st.value = to; el.classList.remove('is-rolling'); }
    };
    st.raf = requestAnimationFrame(step);
  }

  /* ------------------------------------------------------------------ inputs */
  const numberFields = ['hardness', 'iron', 'manganese', 'ph', 'nitrate', 'tds', 'alkalinity', 'billGallons', 'pumpGpm'];
  // fields are text with the decimal keypad, so a decimal comma works: "15,5" reads 15.5, "1,200" reads 1200
  const normNum = v => { v = String(v || '').trim().replace(/\s+/g, ''); return /^-?\d{1,3}(,\d{3})+(\.\d+)?$/.test(v) ? v.replace(/,/g, '') : v.replace(',', '.'); };
  function readForm() {
    numberFields.forEach(k => { const el = form.elements[k]; if (el) state[k] = normNum(el.value); });
    state.unit = form.elements.unit.value;
    const p = parseInt(form.elements.people.value, 10);
    state.people = isFinite(p) ? Math.min(40, Math.max(1, p)) : 4;
  }
  function setPressed(group, value) {
    const radio = group.matches('[role="radiogroup"]');
    $$('button', group).forEach(b => { const on = b.value === String(value); b.setAttribute(radio ? 'aria-checked' : 'aria-pressed', String(on)); if (radio) b.tabIndex = on ? 0 : -1; });
  }
  const more = $('[data-cqss-more]');
  /* Shared setters (G4 17.2, decision 2): the form's own controls and the guided screens both write answers through
     these, so the form and `state` stay the only home of every answer. Each writes the form control and `state` the
     way the v2.1 handlers did, then calls changed(why); `quiet` skips that for a batch that calls changed() once. */
  function setSeg(key, value, quiet) {
    const v = value == null || value === '' ? null : key === 'baths' ? parseInt(value, 10) : String(value);
    state[key] = v;
    const group = $('[data-cqss-seg="' + key + '"]');
    if (group) setPressed(group, v);
    if (key === 'source' && v === 'well' && !guide.on()) accordion.open(more);   // the guided run asks about the well itself
    if (!quiet) changed('seg:' + key);
  }
  function setFlag(key, on, quiet) {
    const chip = $('[data-cqss-flag="' + key + '"]');
    if (chip) chip.setAttribute('aria-pressed', String(!!on));
    state[key] = key === 'extraHeads' ? (on ? 1 : 0) : !!on;
    if (!quiet) changed('flag:' + key);
  }
  function setSign(key, on, quiet) {
    const chip = $('[data-cqss-sign="' + key + '"]');
    if (chip) chip.setAttribute('aria-pressed', String(!!on));
    state.signs = on ? (state.signs.includes(key) ? state.signs : state.signs.concat(key)) : state.signs.filter(x => x !== key);
    if (!quiet) changed('sign:' + key);
  }
  function setField(name, value, quiet) {
    const el = form.elements[name];
    if (!el) return;
    el.value = value == null ? '' : String(value);
    if (name === 'hardness') { state.useEstimate = false; state.hardSource = el.value.trim() ? 'measured' : null; hideFound(); }
    if (!quiet) changed(name === 'unit' || name === 'people' ? name : 'input:' + name);
  }
  $$('[data-cqss-seg]').forEach(group => {
    group.addEventListener('click', e => {
      const b = e.target.closest('button');
      if (!b) return;
      const key = group.dataset.cqssSeg;
      const toggle = group.hasAttribute('data-cqss-toggle');
      setSeg(key, toggle && String(state[key]) === b.value ? null : b.value);
    });
  });
  $$('[data-cqss-flag]').forEach(chip => chip.addEventListener('click', () => setFlag(chip.dataset.cqssFlag, chip.getAttribute('aria-pressed') !== 'true')));
  $$('[data-cqss-sign]').forEach(chip => chip.addEventListener('click', () => setSign(chip.dataset.cqssSign, chip.getAttribute('aria-pressed') !== 'true')));
  $$('[data-cqss-step]').forEach(b => b.addEventListener('click', () => {
    const el = form.elements.people;
    const v = Math.min(40, Math.max(1, (parseInt(el.value, 10) || 4) + parseInt(b.dataset.cqssStep, 10)));
    if (!calm()) el.animate([{opacity: .3, transform: 'translateY(' + (b.dataset.cqssStep > 0 ? 6 : -6) + 'px)'}, {opacity: 1, transform: 'none'}], {duration: 180, easing: EASE});
    setField('people', v);
  }));
  form.addEventListener('input', e => {
    const t = e.target;
    if (!t.name) return;                       // the guided screens' proxy fields carry no name: the guide handles them
    if (t.name === 'hardness') { state.useEstimate = false; state.hardSource = t.value.trim() ? 'measured' : null; hideFound(); }
    if (t.name === 'zip') return;
    changed('input:' + t.name);
  });
  form.addEventListener('change', e => {
    if (e.target.name === 'unit') changed('unit');
    if (e.target.name === 'people') { readForm(); e.target.value = state.people; }
  });

  /* hardness helpers: ZIP and estimate */
  const zipWrap = $('#cqss-zip');
  const found = $('[data-cqss-found]');
  const appear = el => { if (el && !calm()) el.animate([{opacity: 0, transform: 'translateY(-4px)'}, {opacity: 1, transform: 'none'}], {duration: 200, easing: 'cubic-bezier(.22,.61,.36,1)'}); };
  function hideFound() { if (found) { found.hidden = true; found.innerHTML = ''; } }
  // no drawn icon (G4 decision 20): the tinted box and its words carry it
  function showFound(html, warn) {
    const was = found.hidden;
    found.innerHTML = '<span>' + html + '</span>';
    found.classList.toggle('is-warn', !!warn);
    found.hidden = false;
    if (was) appear(found);
  }
  // "Use an estimate" (J227 to J232, shared by the form and the guided hardness and ZIP screens); the caller calls changed()
  function useEstimate() {
    form.elements.hardness.value = '';
    form.elements.unit.value = 'gpg';
    state.useEstimate = true; state.hardSource = 'assumed';
    showFound('We\'ll size on <b>10 gpg</b> and mark it as an estimate. A test strip gives your own number.');
  }
  root.addEventListener('click', e => {
    const b = e.target.closest('[data-cqss-do]');
    if (!b || !root.contains(b)) return;
    const what = b.dataset.cqssDo;
    if (what === 'start' || what === 'full' || what.indexOf('g-') === 0) { guide.act(what, b, e); return; }
    if (what === 'zip') {
      zipWrap.hidden = !zipWrap.hidden;
      b.setAttribute('aria-expanded', String(!zipWrap.hidden));
      if (!zipWrap.hidden) { appear(zipWrap); const z = form.elements.zip; z && z.focus(); }
    } else if (what === 'zip-find') { findZip(); }
    else if (what === 'estimate') { useEstimate(); changed('estimate'); }
    else if (what === 'specialist') { openContact(); }
    else if (what === 'to-result') { scrollToResult(); }
    else if (what === 'to-drawer') { scrollToResult(); }
    else if (what === 'unit-mgl') { form.elements.unit.value = 'mgl'; changed('unit'); }
    else if (what === 'unit-gpg') { form.elements.unit.value = 'gpg'; changed('unit'); }
    else if (what === 'keep-gpg') { keptGpg = String(state.hardness); changed('unit'); }
    else if (what === 'keep-mgl') { keptMgl = String(state.hardness); changed('unit'); }
  });
  if (form.elements.zip) form.elements.zip.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); findZip(); } });

  const loaded = {};
  function loadScript(src) {
    if (!src) return Promise.reject(new Error('no src'));
    if (!loaded[src]) loaded[src] = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = src; s.async = true; s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
    return loaded[src];
  }
  function hardnessGlobal(which) {
    try {
      /* global waterHardnessData, waterHardnessZipCoords */
      if (which === 'data') return typeof waterHardnessData !== 'undefined' ? waterHardnessData : window.waterHardnessData; // eslint-disable-line no-undef
      return typeof waterHardnessZipCoords !== 'undefined' ? waterHardnessZipCoords : window.waterHardnessZipCoords; // eslint-disable-line no-undef
    } catch (_) { return null; }
  }
  /* The one ZIP lookup (G4 17.2): {match:'exact'|'near', city, gpg, ppm, miles} or {match:'bad'|'miss'|'error'}. Shared
     by the form's ZIP box and the guided ZIP screen. The ZIP itself is never stored, put in the URL or sent anywhere;
     the event carries the match only. */
  async function lookupZip(zip) {
    zip = String(zip || '').trim();
    if (!/^\d{5}$/.test(zip)) return {match: 'bad'};
    let data;
    try { await loadScript(root.dataset.hardnessSrc); data = hardnessGlobal('data'); if (!data || !Array.isArray(data.cities)) throw new Error('no data'); }
    catch (_) { track('cq_quiz_zip_lookup', {match: 'error'}); return {match: 'error'}; }
    let hit = null;
    const exact = typeof data.findCityByZip === 'function' ? data.findCityByZip(zip)
      : (data.cities || []).find(c => Array.isArray(c.zips) && c.zips.indexOf(zip) > -1 && typeof c.ppm === 'number');
    if (exact) hit = {match: 'exact', city: exact, miles: 0};
    if (!hit && typeof data.lookupZip === 'function') {
      try {
        await loadScript(root.dataset.zipSrc);
        const r = data.lookupZip(zip, hardnessGlobal('coords'), 50);
        if (r && r.match === 'near' && r.city) hit = r;
      } catch (_) { /* the ZIP points did not load: treated as a miss */ }
    }
    track('cq_quiz_zip_lookup', {match: hit ? hit.match : 'miss'});
    if (!hit || typeof hit.city.ppm !== 'number' || hit.city.flag) return {match: 'miss'};
    const c = hit.city;
    return {match: hit.match, city: c.city + ', ' + c.state, gpg: Math.round(c.ppm / 17.1 * 10) / 10, ppm: c.ppm, miles: hit.miles || 0};
  }
  // writes a looked-up figure into the form (and the form's own found line, so the calculator shows it after a run)
  function applyZip(h, well) {
    form.elements.hardness.value = h.gpg;
    form.elements.unit.value = 'gpg';
    state.useEstimate = false; state.hardSource = 'zip';
    const where = esc(h.city);
    if (well) { showFound('<b>Estimate for your area: about ' + fmt1(h.gpg) + ' gpg</b>, from water reports near ' + where + '. A private well can be harder or softer. Test to confirm.', true); return; }
    showFound(h.match === 'exact'
      ? '<b>' + where + ': about ' + fmt1(h.gpg) + ' gpg</b> (' + fmt(h.ppm) + ' mg/L) from the water utility\'s report. Hardness varies across a service area, and a well has its own.'
      : '<b>Nearest city on our map: ' + where + '</b> (' + fmt(h.miles) + ' miles, not your town): about ' + fmt1(h.gpg) + ' gpg. A test strip confirms your own tap.', h.match !== 'exact');
  }
  async function findZip() {
    const zip = String(form.elements.zip.value || '').trim();
    if (!/^\d{5}$/.test(zip)) { showFound('Enter a 5-digit ZIP code.', true); return; }
    showFound('Looking up ' + esc(zip) + '...');
    const h = await lookupZip(zip);
    if (h.match === 'error') { showFound('Our hardness map did not load just now. Enter the number from a test strip or water report.', true); return; }
    if (h.match !== 'exact' && h.match !== 'near') { showFound('We do not have confirmed hardness for ' + esc(zip) + ' yet. A test strip gives your number.', true); return; }
    applyZip(h, state.source === 'well');
    changed('zip');
  }

  /* ------------------------------------------------------------------ products */
  const lead = v => { const m = String(v || '').match(/\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; };
  function variantFor(productKey, want) {
    const p = catalog[productKey];
    if (!p || !Array.isArray(p.variants) || !p.variants.length) return null;
    const names = (p.options || []).map(o => String(o).toLowerCase());
    const idx = re => names.findIndex(n => re.test(n));
    const iConfig = idx(/configuration/), iStructure = idx(/structure/), iSize = idx(/cubic|resin|media|size/), iFlow = idx(/flow/), iValve = idx(/valve/);
    const ok = v => {
      const o = v.options || [];
      if (want.config && iConfig > -1 && o[iConfig] !== want.config) return false;
      if (iStructure > -1 && !/^fiberglass/i.test(o[iStructure] || '')) return false;
      if (want.size != null && iSize > -1 && lead(o[iSize]) !== want.size) return false;
      if (want.flow && iFlow > -1 && o[iFlow] !== want.flow) return false;
      if (iValve > -1 && want.flow && !/^automatic$/i.test(o[iValve] || '') && p.variants.some(x => (x.options || [])[iFlow] === want.flow && /^automatic$/i.test((x.options || [])[iValve] || ''))) return false;
      return true;
    };
    const v = p.variants.find(x => ok(x) && x.available) || p.variants.find(ok);
    return v ? {product: p, variant: v, key: productKey} : null;
  }
  // which product carries the softener for this result and setup
  const SETUPS = {
    softener: {product: 'softener', config: 'Standalone', label: 'Softener only'},
    smart: {product: 'smart', config: 'With Softener', label: 'Plus SMART filter', name: 'Water softener with SMART filter', both: 'Softener and SMART filter'},
    metal: {product: 'metal', config: 'With Softener', label: 'Plus Metal Removal', name: 'Water softener with Metal Removal filter', both: 'Softener and Metal Removal filter'},
    'metal-smart': {product: 'metal', config: 'With SMART Filter and Softener', label: 'Plus SMART too', name: 'Water softener with Metal Removal and SMART filters', both: 'Softener, Metal Removal and SMART filters'},
    tannin: {product: 'tannin', config: 'With Softener', label: 'Plus tannin system', name: 'Water softener with tannin system', both: 'Softener and tannin system'},
    neutralizer: {product: 'neutralizer', config: 'With Softener', label: 'Plus acid neutralizer', name: 'Water softener with acid neutralizer', both: 'Softener and acid neutralizer'},
    nitrate: {product: 'nitrate', config: 'With Softener', label: 'Plus nitrate system', name: 'Water softener with nitrate system', both: 'Softener and nitrate system'}
  };
  function setupsFor(r, size) {
    if (size.kind === 'com') return [];
    const a = r.ahead;
    if (a.length === 1) {
      const k = a[0];
      if (k === 'metal') return state.source === 'city' ? ['metal', 'metal-smart'] : (r.iron.required || state.signs.includes('smell') ? ['metal', 'metal-smart'] : ['metal', 'softener']);
      return [k];
    }
    if (a.length > 1) return ['softener'];
    return state.source === 'city' ? ['softener', 'smart'] : ['softener'];
  }
  const itemFor = s => s.kind === 'com' ? variantFor('commercial', {flow: s.select.flow}) : variantFor('softener', {config: 'Standalone', size: s.cuft});
  function chosen(r) {
    const size = r.sizes.find(x => x.key === (state.choice && r.sizes.some(s => s.key === state.choice) ? state.choice : r.pick));
    const setups = setupsFor(r, size);
    const setupKey = state.setup && setups.includes(state.setup) ? state.setup : setups[0];
    let item;
    if (size.kind === 'com') item = itemFor(size);
    else {
      const st = SETUPS[setupKey] || SETUPS.softener;
      item = variantFor(st.product, {config: st.config, size: size.cuft}) || itemFor(size);
    }
    return {size, setups, setupKey, item};
  }

  /* ------------------------------------------------------------------ render helpers */
  const pane = $('[data-cqss-pane]');
  const matchEl = $('[data-cqss-match]');
  const notesEl = $('[data-cqss-notes]');
  const cardsEl = $('[data-cqss-cards]');
  const dock = $('[data-cqss-dock]');
  const pref = $('[data-cqss-pref]');
  const tabs = $('[data-cqss-tabs]');
  const sizeNum = s => s.kind === 'res' ? (s.cuft === 1.5 ? '1.5' : '2.0') : String(s.cuft);
  const sizeName = s => sizeNum(s) + '\u00a0cu\u00a0ft' + (s.kind === 'com' ? ' commercial' : '');
  const daysText = n => n >= 14 ? 'every 14 days' : n === 1 ? 'every day' : 'every ' + n + ' days';
  const isSoft = r => r.ready && r.water.gpg < 1 && r.water.source !== 'assumed';
  const CARET = '<span class="cqss-caret" aria-hidden="true"></span>';
  const CHAT = '<svg class="cqss-chat" viewBox="0 0 20 20" width="18" height="18" aria-hidden="true" focusable="false"><path d="M4 4.5h12a1.5 1.5 0 0 1 1.5 1.5v7a1.5 1.5 0 0 1-1.5 1.5H8.5L5 17v-2.5H4A1.5 1.5 0 0 1 2.5 13V6A1.5 1.5 0 0 1 4 4.5Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';

  /* ------------------------------------------------------------------ the result pane (updated in place) */
  const P = {
    size: $('[data-cqss-size]'), num: $('[data-cqss-size-num]'), unit: $('[data-cqss-size-unit]'), sub: $('[data-cqss-size-sub]'),
    math: $('[data-cqss-math]'), gallons: $('[data-cqss-roll="gallons"]'), grains: $('[data-cqss-roll="grains"]'), galLabel: $('[data-cqss-gal-label]'),
    gpg: $('[data-cqss-gpg]'), gpgTile: $('[data-cqss-gpg-tile]'), gpgLabel: $('[data-cqss-gpg-label]'), assumed: $('[data-cqss-assumed]'),
    flow: $('[data-cqss-flow]'), start: $('[data-cqss-start]'), rated: $('[data-cqss-size-rated]'), stats: $('[data-cqss-res-stats]'),
    eqBox: $('[data-cqss-eqbox]'), eqGal: $('[data-cqss-eq="gallons"]'), eqGpg: $('[data-cqss-eq="gpg"]'), eqGrains: $('[data-cqss-eq="grains"]'),
    eqGalLabel: $('[data-cqss-eq-gal]'), eqGpgLabel: $('[data-cqss-eq-gpg]'), links: $('[data-cqss-res-links]'), acts: $('[data-cqss-res-acts]')   // v3 stage 1: the capacity meter markup is retired (G4 5.6 item 17)
  };
  const EMPTY_SUB = P.sub ? P.sub.textContent : '';
  const capFirst = t => t.charAt(0).toUpperCase() + t.slice(1);
  const shortName = z => sizeNum(z) + ' cu ft';
  const priceOf = z => { const it = itemFor(z); return it && it.variant ? it.variant.price : null; };
  const saltGap = (a, b) => a && b && a.saltMonth != null && b.saltMonth != null ? Math.round(a.saltMonth - b.saltMonth) : 0;
  /* G4 5.7: one line on why this size, from engine values only (the math is unchanged). Read in order; the first that
     applies wins. Never a weekly rule: it says how often each size regenerates and which one we recommend. */
  function whyLine(r, c) {
    const s = c.size, sizes = r.sizes, at = sizes.indexOf(s);
    const shown = r.shown.map(k => sizes.find(z => z.key === k)).filter(Boolean);
    const smaller = shown.filter(z => sizes.indexOf(z) < at), larger = shown.filter(z => sizes.indexOf(z) > at);
    const pick = sizes.find(z => z.key === r.pick);
    if (state.choice && state.choice !== r.pick && pick) {
      const more = saltGap(s, pick);
      return 'We recommend the ' + sizeName(pick) + '. Yours regenerates ' + everyDays(s.timer) + (more >= 2 ? ', on about ' + more + ' lb more salt a month' : '') + '.';
    }
    if (state.preference === 'cost' && s.capFit === 'tight') return 'It regenerates ' + everyDays(s.timer) + '. One size up regenerates less often.';
    const tight = smaller.filter(z => z.capFit === 'tight' && z.flowFit === 'ok').pop();
    if (tight && shown.length < 2) {
      const pt = priceOf(tight), ps = priceOf(s), saves = saltGap(tight, s);
      return 'The ' + sizeName(tight) + ' also works' + (pt != null && ps != null && pt < ps ? ' and costs less up front' : '') + '. It would regenerate ' + everyDays(tight.timer) +
        '. We recommend the ' + sizeName(s) + ' because it regenerates less often' + (saves >= 2 ? ', on about ' + saves + ' lb less salt a month' : '') + '.';
    }
    const flowNo = smaller.filter(z => z.flowFit === 'no').pop();
    if (flowNo) return 'Your busiest minute is about ' + fmt1(r.flow.peak) + ' GPM, more than the ' + sizeName(flowNo) + ' is rated to pass. The ' + sizeName(s) + ' keeps the pressure up.';
    const capNo = smaller.filter(z => z.capFit === 'no').pop();
    if (capNo) return 'The ' + sizeName(capNo) + ' would regenerate ' + (capNo.timer >= 1 ? everyDays(capNo.timer) : 'more than once a day') + ' at this hardness, too often for a home softener.';
    const same = larger.find(z => z.fit !== 'no' && z.timer === s.timer);
    if (same && s.timer >= 14) return '14 days is the longest we set the timer, to keep the resin fresh, so a bigger tank would not regenerate less often.';
    if (same && r.notes.some(n => n.id === 'metals')) return 'With iron or manganese in the water we set the timer to 7 days at most, to keep the resin clean, so a bigger tank would not regenerate less often.';
    const up = shown.length < 2 && larger.find(z => z.fit !== 'no');
    if (up) { const pu = priceOf(up), ps = priceOf(s); return 'The ' + sizeName(up) + ' also fits. It would regenerate ' + everyDays(up.timer) + (pu != null && ps != null && pu > ps ? ' and costs more up front' : '') + '.'; }
    return shown.length < 2 ? 'It keeps up with your water and your busiest minute.' : '';
  }
  /* G4 5.6 row 6: how often each shown size regenerates. Bars are timer days out of 14; a size that does not fit has
     no bar and reads "Too small". The tag says why a row matters. */
  function renderRows(r, c) {
    const list = $('[data-cqss-rows-list]');
    if (!list) return;
    const sizes = r.shown.map(k => r.sizes.find(z => z.key === k)).filter(Boolean);
    const pp = priceOf(c.size), salt = r.kcl ? 'potassium' : 'salt';
    list.innerHTML = sizes.map((z, i) => {
      const isPick = z.key === r.pick, isChoice = !!state.choice && z.key === state.choice && z.key !== r.pick, fits = z.fit !== 'no', pz = priceOf(z);
      const tag = isChoice ? 'Your choice' : isPick ? 'We recommend' : z.capFit === 'no' ? 'Too small for your water' : z.flowFit === 'no' ? 'Too small for your busiest minute'
        : z.flowFit === 'tight' ? 'Pressure dips at peak' : pz != null && pp != null && pz < pp && z.timer >= 4 ? 'Costs less' : '';
      return '<li' + (z.key === c.size.key ? ' class="is-pick"' : '') + ' style="--i:' + i + '"><span class="cqss-row-size"><b>' + esc(shortName(z)) + '</b>' +
        '<span class="cqss-row-tag' + (isPick && !state.choice || isChoice ? ' is-pick' : '') + '">' + esc(fmt(z.rated) + '\u00a0grains' + (tag ? ' \u00b7 ' + tag : '')) + '</span></span>' +
        '<span class="cqss-row-bar' + (fits ? '' : ' is-none') + '" aria-hidden="true">' + (fits ? '<i style="--w:' + (Math.max(1, Math.min(14, z.timer)) / 14).toFixed(3) + '"></i>' : '') + '</span>' +
        '<span class="cqss-row-val">' + (fits ? '<b>' + esc(everyDays(z.timer)) + '</b>' + (z.saltMonth != null ? '<small>' + fmt(z.saltMonth) + '\u00a0lb of ' + salt + ' a month</small>' : '') : '<b>Too small</b>') + '</span></li>';
    }).join('');
  }
  // the top of the card: gallons a day x hardness = grains a day, live; question marks until there is a result
  const shownGrains = r => Math.round(Math.round(r.demand.gallons) * Number(fmt1(r.water.comp).replace(/,/g, '')));
  function eqBlank() {
    [P.eqGal, P.eqGrains].forEach(n => { if (!n) return; const st = rolls.get(n); if (st) cancelAnimationFrame(st.raf); rolls.delete(n); n.classList.remove('is-rolling'); n.firstElementChild.textContent = '?'; });
    if (P.eqGpg) P.eqGpg.textContent = '?';
    if (P.eqGalLabel) P.eqGalLabel.textContent = 'gal a day';
    if (P.eqGpgLabel) P.eqGpgLabel.innerHTML = 'gpg<span class="cqss-eq-more"> hardness</span>';
    if (P.eqBox) P.eqBox.classList.add('is-blank');
  }
  function eqFill(r) {
    if (!P.eqBox) return;
    P.eqBox.classList.remove('is-blank');
    roll(P.eqGal, r.demand.gallons);
    // past 150 gpg: the number the visitor entered, labelled as sized at 150 (the engine's cap)
    const entered = isBeyond() ? S.toGpg(state.hardness, state.unit) : null;
    P.eqGpg.textContent = entered != null ? fmt1(entered) : fmt1(r.water.comp);
    P.eqGpgLabel.innerHTML = entered != null ? 'gpg, sized at 150' : r.water.comp !== r.water.gpg ? 'gpg to remove' : r.water.source === 'assumed' ? 'gpg, assumed' : 'gpg<span class="cqss-eq-more"> hardness</span>';
    P.eqGalLabel.textContent = r.demand.basis === 'bill' ? 'gal a day, bill' : 'gal a day';
    roll(P.eqGrains, shownGrains(r));
  }
  function renderPane(r, c) {
    if (r.slip) {
      // G4 5.11: the calculator's unit check, in the same words as the guided check screen
      const v = parseFloat(state.hardness), vt = trimNum(v), conv = fmt1(S.toGpg(v, 'mgl'));
      P.size.hidden = true; P.links.hidden = true; if (P.rated) P.rated.hidden = true; eqBlank();
      P.sub.hidden = false; if (P.stats) P.stats.hidden = true;
      setText(P.sub, 'Check your hardness first.', true);
      P.math.hidden = true; P.flow.hidden = true; P.assumed.hidden = true; P.start.hidden = true;
      matchEl.hidden = false;
      const key = 'slip|' + v;
      if (drawerKey !== key) {
        drawerKey = key;
        matchEl.innerHTML = '<h3 class="cqss-match-name">Is that ' + esc(vt) + ' mg/L?</h3>' +
          '<p class="cqss-help-dark">Water reports often list hardness in mg/L. ' + esc(vt) + ' mg/L is ' + conv + ' gpg. Fewer than 1 in 300 cities on our hardness map report more than 30 gpg.</p>' +
          '<div class="cqss-buy"><button type="button" class="cqv-btn" data-cqss-do="unit-mgl">Yes, it\'s mg/L</button><button type="button" class="cqv-btn cqv-btn-ghost" data-cqss-do="keep-gpg">No, it\'s ' + esc(vt) + ' gpg</button></div>';
        appear(matchEl);
      }
      return;
    }
    P.size.hidden = false;
    if (!r.ready) {
      P.size.classList.add('is-empty'); P.size.classList.remove('is-soft');
      P.num.textContent = ''; P.unit.textContent = 'cu ft';
      P.sub.hidden = false;
      if (P.stats) {                                      // the empty card previews the result: question marks
        P.stats.hidden = false; P.stats.classList.add('is-blank');
        $$('[data-cqss-stat]', P.stats).forEach(b => { b.textContent = '?'; });
        P.stats.querySelector('[data-cqss-stat-salt]').textContent = 'salt a month';
      }
      setText(P.sub, EMPTY_SUB, true);
      setText($('.cqss-pane > .cqss-kicker'), 'Your size', true);
      P.math.hidden = true; P.flow.hidden = true; P.assumed.hidden = true;
      P.start.hidden = false; matchEl.hidden = true;
      P.links.hidden = true; if (P.rated) P.rated.hidden = true;
      eqBlank();                                         // no product until there is a recommendation
      return;
    }
    const s = c.size, soft = isSoft(r), beyond = isBeyond();
    eqFill(r);
    const wasEmpty = P.size.classList.contains('is-empty');
    P.size.classList.remove('is-empty');
    P.size.classList.toggle('is-soft', soft);
    setText($('.cqss-pane > .cqss-kicker'), beyond ? 'At least' : soft ? 'Your water' : state.choice && state.choice !== r.pick ? 'Your choice' : 'We recommend', true);
    setText(P.num, soft ? 'Soft' : sizeNum(s), wasEmpty);
    setText(P.unit, soft ? 'water' : 'cu ft' + (s.kind === 'com' ? ' commercial' : ''), wasEmpty);
    if (P.rated) { P.rated.hidden = soft || !s.rated; if (!P.rated.hidden) setText(P.rated, 'Rated ' + fmt(s.rated) + '\u00a0grains', wasEmpty); }
    const salt = r.kcl ? 'potassium' : 'salt';
    const ahead = r.ahead.map(k => AHEAD[k]).filter(Boolean);
    const tail = 'regenerates ' + everyDays(s.timer) + (s.saltMonth != null ? ', on about ' + fmt(s.saltMonth) + '\u00a0lb of ' + salt + ' a month.' : '.');
    const full = !soft && !beyond;
    // the size's own numbers as a row (days between regenerations, salt a month, grains a day); with the row showing,
    // the sentence keeps only what the row cannot say (the stages that go ahead of the softener)
    const stats = full && s.timer > 0 && !!P.stats;
    if (P.stats) {
      P.stats.classList.remove('is-blank');
      P.stats.hidden = !stats;
      if (stats) {
        const q = k => P.stats.querySelector('[data-cqss-stat="' + k + '"]');
        setText(q('days'), (s.timer >= 14 ? 14 : s.timer) + (s.timer === 1 ? '\u00a0day' : '\u00a0days'));
        setText(q('salt'), s.saltMonth != null ? fmt(s.saltMonth) + '\u00a0lb' : 'n/a');
        setText(q('grains'), fmt(shownGrains(r)));
        P.stats.querySelector('[data-cqss-stat-salt]').textContent = salt + ' a month';
      }
    }
    const aheadLine = ahead.length ? capFirst(ahead.join(' and ')) + (ahead.length > 1 ? ' go' : ' goes') + ' ahead of the softener.' : '';
    setText(P.sub, beyond ? 'We size up to 150 gpg. Your water is harder, so a specialist confirms the size.'
      : soft ? 'Under 1 gpg there is little hardness to remove. You may not need a salt-based softener.'
      : stats ? aheadLine
      : ahead.length ? 'The softener ' + tail + ' ' + capFirst(ahead.join(' and ')) + (ahead.length > 1 ? ' go' : ' goes') + ' ahead of it.'
      : 'It ' + tail);
    P.sub.hidden = !P.sub.textContent;
    const whyEl = $('[data-cqss-why-line]'), rowsEl = $('[data-cqss-rows]'), wk = $('[data-cqss-workings]');
    const whyText = full ? whyLine(r, c) : '';
    if (whyEl) { whyEl.hidden = !whyText; if (whyText) setText(whyEl, whyText, true); }
    if (rowsEl) { rowsEl.hidden = !full; if (full) renderRows(r, c); }
    if (wk) wk.hidden = !full;
    P.links.hidden = !full;
    P.math.hidden = !full;
    roll(P.gallons, r.demand.gallons); roll(P.grains, shownGrains(r));
    P.galLabel.textContent = r.demand.basis === 'bill' ? 'gal a day (bill)' : 'gal a day';
    P.gpg.textContent = fmt1(r.water.comp);
    P.gpgLabel.textContent = r.water.comp !== r.water.gpg ? 'gpg to remove' : 'gpg';
    P.gpgTile.classList.toggle('is-assumed', r.water.source === 'assumed');
    P.assumed.hidden = r.water.source !== 'assumed';
    P.start.hidden = true;
    if (full && s.timer > 0) {
      P.flow.hidden = false;
      P.flow.innerHTML = 'Busiest minute: <b>' + fmt1(r.flow.peak) + ' GPM</b>, ' + (s.flowFit === 'ok' ? 'within' : 'above') + ' its ' + esc(s.printed.replace(' service', '').replace(/ to /g, ' to ')) + ' rating.';
    } else { P.flow.hidden = true; }
    renderDrawer(r, c);
  }

  /* the white drawer: product, setup, price, Add to cart */
  const typeTile = z => '<span class="cqss-type-tile" aria-hidden="true"><b>' + esc(sizeNum(z)) + '</b><small>cu ft</small></span>';
  let drawerKey = '';
  function renderDrawer(r, c) {
    matchEl.hidden = false;
    if (isSoft(r)) {
      P.acts.innerHTML = '';
      if (drawerKey !== 'soft') {
        drawerKey = 'soft';
        matchEl.innerHTML = '<span class="cqss-kicker">Your water</span><h3 class="cqss-match-name">Your water is already soft.</h3>' +
          '<p class="cqss-help-dark">You may not need a salt-based softener. If you still see scale or spots, a water test shows what is causing them.</p>' +
          '<div class="cqss-buy">' + (catalog.test ? '<a class="cqv-btn" href="' + esc(catalog.test.url) + '">Get a water test</a>' : '') + '<button type="button" class="cqv-btn cqv-btn-ghost" data-cqss-do="specialist">Have a specialist check it</button></div>';
      }
      return;
    }
    const s = c.size, beyond = isBeyond(), big = isBig(s);
    const item = c.item;
    const unusual = r.water.gpg > 60 && (kept() || beyond);
    const key = 'item|' + (item ? 'y' : 'n') + '|' + c.setups.join(',') + '|' + (unusual ? 'u' : '');
    if (key !== drawerKey) {
      drawerKey = key;
      matchEl.innerHTML =
        '<div class="cqss-match-top"><div class="cqss-match-thumb" data-d="thumb" aria-hidden="true"></div><div class="cqss-match-head">' +
        '<div class="cqss-name-row"><h3 class="cqss-match-name" data-d="name"></h3>' + (item ? '<span class="cqss-price" data-d="price"></span>' : '') + '</div>' +
        '<p class="cqss-match-config"><span data-d="config"></span>' + (item ? '<span data-d="priceLabel"></span>' : '') + '</p></div></div>' +
        (c.setups.length > 1 ? '<div class="cqss-setup"><div class="cqss-seg" role="radiogroup" aria-label="Setup" data-cqss-setup>' +
          c.setups.map(k => '<button type="button" role="radio" value="' + k + '" aria-checked="false" tabindex="-1">' + esc(SETUPS[k].label) + '</button>').join('') + '</div></div>' : '') +
        '<p class="cqss-help-dark" data-d="why" hidden></p>' +
        (item ? '<div class="cqss-buy"><button type="button" class="cqv-btn" data-cqss-add>Add to cart</button></div>' +
          '<div class="cqss-after-buy"><button type="button" class="cqss-spec-link" data-cqss-do="specialist">' + CHAT + '<span>Not sure? Have a specialist check it</span></button>' +
          (unusual && catalog.test ? '<a class="cqss-spec-link" data-d="lab" href="' + esc(catalog.test.url) + '"></a>' : '') + '</div>' +
          '<p class="cqss-cart-msg" data-cqss-cart-msg role="alert" hidden></p>'
          : '<div class="cqss-buy"><button type="button" class="cqv-btn" data-cqss-do="specialist">Have a specialist size it</button></div>');
      // Configure and Share sit in the eyebrow beside How we sized it, as on the Well Water result
      P.acts.innerHTML = item ? '<button type="button" class="cqv-text-btn" data-cq-choose-options aria-controls="CQOptionPicker" data-cqss-configure>Configure</button>' +
        '<button type="button" class="cqv-text-btn" data-cqss-share>Share</button>' : '';
      const seg = matchEl.querySelector('[data-cqss-setup]');
      if (seg) {
        seg.addEventListener('click', e => { const b = e.target.closest('button'); if (!b) return; state.setup = b.value; track('cq_quiz_answer', {screen: 'setup', value: b.value}); render(); });
        seg.addEventListener('keydown', e => {
          if (!/^Arrow(Left|Right)$/.test(e.key)) return;
          const bs = $$('button', seg), i = bs.indexOf(document.activeElement);
          if (i < 0) return;
          const n = bs[(i + (e.key === 'ArrowRight' ? 1 : bs.length - 1)) % bs.length];
          n.click(); n.focus(); e.preventDefault();
        });
        setPressed(seg, c.setupKey);
        mountThumb(seg);
      }
    }
    const d = n => matchEl.querySelector('[data-d="' + n + '"]');
    const seg = matchEl.querySelector('[data-cqss-setup]');
    if (seg) setPressed(seg, c.setupKey);
    const setup = c.setups.length && c.setupKey !== 'softener' ? SETUPS[c.setupKey] : null;
    setText(d('name'), setup && setup.name ? setup.name : item ? item.product.title : 'Water softener');
    // no grain rating here until AJ settles the capacity basis (README open decision 1); the size and pipe are listing facts
    setText(d('config'), s.kind === 'res' ? sizeName(s) + ' softener' : sizeName(s) + ', ' + s.pipe + '\u00a0in pipe');
    // the reason lives in the pane's why line now (G4 5.7); the drawer only adds the lab test line for unusually hard water
    const why = beyond ? 'Your number is past what this calculator sizes, so this is the system for 150 gpg. A specialist confirms the size for your water.'
      : big ? 'A tank this size is built for commercial flows. A specialist can confirm it, or suggest a twin or metered system, before you buy.'
      : unusual ? 'At ' + fmt1(r.water.gpg) + ' gpg, a lab test confirms the number before you buy.' : '';
    const w = d('why'); w.hidden = !why; if (why) setText(w, why, true);
    const lab = d('lab');
    if (lab && catalog.test) { const tv = catalog.test.variants && catalog.test.variants[0]; lab.textContent = 'Order a lab test' + (tv && tv.price ? ', ' + money(tv.price) : ''); }
    /* G4 13: the chosen variant's own photo on plain white, never blended, sampled or cross-faded with the old one. A
       commercial variant without its own photo, a failed load or a slow decode shows the size in type instead. */
    const media = d('thumb');                       // the product photo sits beside its name and price
    const v = item && item.variant;
    const img = v ? (s.kind === 'com' && v.own === false ? null : (v.image || item.product.image)) : null;
    const want = img || 'type:' + sizeNum(s);
    if (media.dataset.src !== want) {
      media.dataset.src = want;
      media.innerHTML = img ? '' : typeTile(s);
      if (img) {
        const n = new Image(); n.alt = ''; n.width = 900; n.height = 900; n.decoding = 'async';
        const slow = setTimeout(() => { if (media.dataset.src === want && !media.querySelector('img')) media.innerHTML = typeTile(s); }, 700);
        n.onload = () => { clearTimeout(slow); if (media.dataset.src !== want) return; media.innerHTML = ''; media.appendChild(n); if (!calm()) n.animate([{opacity: 0}, {opacity: 1}], {duration: 200, easing: 'ease'}); };
        n.onerror = () => { clearTimeout(slow); if (media.dataset.src === want) media.innerHTML = typeTile(s); };
        n.src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=900';
      }
    }
    if (item) {
      setText(d('price'), money(item.variant.price));
      d('priceLabel').textContent = setup ? setup.both : s.kind === 'com' ? (s.select.flow || 'Commercial') + ', fiberglass tank' : 'Fiberglass tank, pre and post filters';
      const add = matchEl.querySelector('[data-cqss-add]');
      add.disabled = !item.variant.available; add.textContent = item.variant.available ? 'Add to cart' : 'Sold out';
      const cfg = P.acts.querySelector('[data-cqss-configure]');
      cfg.dataset.productUrl = item.variant.url || item.product.url + '?variant=' + item.variant.id;
    }
  }

  /* ------------------------------------------------------------------ notes, below the console */
  let notesKey = '';
  const bags = lb => { const a = Math.floor(lb / 40), b = Math.ceil(lb / 40); return a < 1 ? 'about one bag' : a === b ? a + ' bags' : a + ' to ' + b + ' bags'; };
  function renderNotes(r, c) {
    if (!r.ready || !r.notes.length) { notesEl.hidden = true; notesEl.innerHTML = ''; notesKey = ''; return; }
    const links = {
      metal: catalog.metal && {href: catalog.metal.url, label: 'See the Metal Removal filter'},
      tannin: catalog.tannin && {href: catalog.tannin.url, label: 'See the tannin system'},
      neutralizer: catalog.neutralizer && {href: catalog.neutralizer.url, label: 'See the acid neutralizer'},
      nitrate: catalog.nitrate && {href: catalog.nitrate.url, label: 'See the nitrate system'},
      assumed: catalog.test && {href: catalog.test.url, label: 'Get a water test'},
      slight: catalog.conditioner && {href: catalog.conditioner.url, label: 'See the salt-free conditioner'},
      citycond: catalog.conditioner && {href: catalog.conditioner.url, label: 'See the salt-free conditioner'},
      soft: catalog.conditioner && {href: catalog.conditioner.url, label: 'See the salt-free conditioner'},
      tds: {href: '/pages/water-wizard', label: 'Plan it in the Water Wizard'},
      beyond: null
    };
    if (r.ahead.length > 1) links.multi = {href: '/pages/water-wizard', label: 'Plan every stage in the Water Wizard'};
    links.veryhard = catalog.test && {href: catalog.test.url, label: 'Order a lab test'};
    const bigPick = !!c && (isBig(c.size) || isBeyond());
    let items = r.notes.filter(n => !(n.id === 'soft' && isSoft(r)) && n.id !== 'weekly' && !(n.id === 'oversize' && bigPick));
    const vh = items.find(n => n.id === 'veryhard');
    if (vh) {
      const z = c && c.size, salt = r.kcl ? 'potassium' : 'salt';
      const text = isBeyond() ? 'Over 150 gpg is past what this calculator sizes. A lab test checks your number and measures the dissolved solids, iron and pH that can change the setup.'
        : 'Fewer than 1 in 300 cities on our hardness map report more than 30 gpg, so ' + fmt1(r.water.gpg) + ' gpg is worth confirming. A lab test checks your number and measures the dissolved solids, iron and pH that can change the setup.' +
          (z && z.saltMonth != null ? ' At this hardness that is ' + bags(z.saltMonth) + ' of 40 lb ' + salt + ' a month.' : '');
      items = [Object.assign({}, vh, {title: 'Unusually hard water', text})].concat(items.filter(n => n !== vh));
    }
    if (state.hardSource === 'zip' && state.source === 'well') {
      items = items.filter(n => n.id !== 'zip');   // the engine's utility-figure note is for city water
      items.push({id: 'areaest', level: 'info', title: 'Your hardness is an area estimate', text: 'It comes from water reports near your ZIP code. A private well can be much harder or softer, so a water test confirms the size.'});
      links.areaest = catalog.test && {href: catalog.test.url, label: 'Get a water test'};
    }
    if (r.ahead.length > 1) items.unshift({id: 'multi', level: 'route', title: 'More than one stage ahead of the softener', text: 'Your water needs ' + r.ahead.length + ' treatment stages in order. The softener size here stays the same; the Water Wizard plans the full setup.'});
    const key = items.map(n => n.id + n.text).join('|');
    if (!items.length) { notesEl.hidden = true; notesEl.innerHTML = ''; notesKey = ''; return; }
    if (key === notesKey) return;
    const fresh = notesEl.hidden;
    notesKey = key;
    notesEl.innerHTML = items.map(n => {
      const l = links[n.id];
      return '<li class="cqss-note' + (n.level === 'warn' ? ' is-warn' : n.level === 'health' ? ' is-health' : n.level === 'route' ? ' is-route' : '') + '">' +
        '<span><b>' + esc(n.title) + '</b>' + esc(n.text) + (l ? ' <a href="' + esc(l.href) + '">' + esc(l.label) + '</a>' : '') + '</span></li>';
    }).join('');
    notesEl.hidden = false;
    if (!calm()) $$('.cqss-note', notesEl).forEach((li, i) => li.animate([{opacity: 0, transform: 'translateY(8px)'}, {opacity: 1, transform: 'none'}], {duration: 280, delay: (fresh ? i : 0) * 50, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'backwards'}));
  }

  /* ------------------------------------------------------------------ every size: cards updated in place, FLIP */
  const cards = new Map();
  $$('[data-cqss-card]', cardsEl).forEach(el => cards.set(el.dataset.cqssCard, el));
  function makeCard(s) {
    const el = document.createElement('article');
    el.className = 'cqss-card';
    el.dataset.cqssCard = s.key;
    el.innerHTML = '<div class="cqss-card-media"><span class="cqss-badge" data-cqss-f="badge">Recommended</span></div>' +
      '<div class="cqss-card-head"><span class="cqss-card-label" data-cqss-f="label"></span><h3 class="cqss-card-name" data-cqss-f="name"></h3><p class="cqss-card-sub" data-cqss-f="sub"></p><span class="cqss-flag" data-cqss-f="flag" hidden></span></div>' +
      '<ul class="cqss-card-nums" data-cqss-f="nums"><li><b data-cqss-n="0"></b><small data-cqss-l="0"></small></li><li><b data-cqss-n="1"></b><small data-cqss-l="1"></small></li><li><b data-cqss-n="2"></b><small data-cqss-l="2"></small></li></ul>' +
      '<div class="cqss-card-specs"><button type="button" class="cqss-pop-btn" aria-expanded="false" data-cqss-pop><span>Specs and math</span><span class="cqss-q" aria-hidden="true">?</span></button>' +
      '<div class="cqss-pop" role="group" aria-label="Specs and math" hidden><dl data-cqss-f="specs"></dl></div></div>' +
      '<div class="cqss-card-foot"><span class="cqss-card-price" data-cqss-f="price"></span><span data-cqss-f="btn"></span></div>';
    cards.set(s.key, el);
    return el;
  }
  // the label over a card's name; a size this priority rules out keeps its place, greyed out with the reason
  // (AJ: greyed out, never hidden)
  function cardLabel(s, r, choiceKey) {
    const isPick = s.key === choiceKey, isRec = s.key === r.pick, soft = isSoft(r);
    if (s.fit === 'no' && !isPick && !isRec) return ruledWhy(s, r);
    return isPick ? (isRec ? (soft ? 'If you still want one' : 'Your match') : 'Your choice') : isRec ? 'Our match'
      : s.fit === 'tight' ? (s.flowFit === 'tight' ? 'Fits, pressure dips at peak' : 'Fits, regenerates often') : s.oversized ? 'Fits, a big bed for home flows' : 'Also fits';
  }
  // the label is as tall as its longest wording under any priority (an invisible copy of each sits in the same grid
  // cell), so a wording that wraps on a narrow card never pushes the numbers down
  function setLabel(el, text, hold) {
    let t = el.querySelector('.cqss-lbl-t');
    if (!t) {
      el.textContent = '';
      t = document.createElement('span'); t.className = 'cqss-lbl-t';
      const h = document.createElement('span'); h.className = 'cqss-lbl-h'; h.setAttribute('aria-hidden', 'true');
      el.append(t, h);
    }
    setText(t, text, true);
    el.querySelector('.cqss-lbl-h').innerHTML = hold.map(x => '<span>' + esc(x) + '</span>').join('');
  }
  function fillCard(el, s, r, c, hold) {
    const f = n => el.querySelector('[data-cqss-f="' + n + '"]');
    const item = itemFor(s);
    const isPick = s.key === c.size.key, isRec = s.key === r.pick, soft = isSoft(r);
    const ruled = s.fit === 'no' && !isPick && !isRec;
    el.classList.toggle('is-pick', isPick);
    el.classList.toggle('is-ruled', ruled);
    f('badge').textContent = soft && isRec ? 'Smallest size' : isPick && !isRec ? 'Your choice' : 'Recommended';
    const label = cardLabel(s, r, c.size.key);
    setLabel(f('label'), label, (hold || []).concat(label));
    f('name').textContent = sizeNum(s) + '\u00a0cu\u00a0ft' + (s.kind === 'com' ? ' commercial' : '');   // the size never splits from its unit
    f('sub').textContent = fmt(s.rated) + ' grain softener, ' + s.tank + ' tank';
    const flag = f('flag'); flag.hidden = ruled || s.flowFit !== 'tight'; flag.textContent = 'Pressure dips at your busiest minute';
    const nums = [
      [s.timer > 0 ? s.timer + (s.timer === 1 ? ' day' : ' days') : 'Daily', 'between regenerations'],
      [s.saltMonth != null ? fmt(s.saltMonth) + ' lb' : 'n/a', (r.kcl ? 'potassium' : 'salt') + ' a month'],
      [s.costMonth != null ? '$' + fmt(s.costMonth) : 'n/a', 'to run a month']
    ];
    nums.forEach((n, i) => { const b = el.querySelector('[data-cqss-n="' + i + '"]'); setText(b, n[0]); el.querySelector('[data-cqss-l="' + i + '"]').textContent = n[1]; });
    f('specs').innerHTML = [
      ['Usable at ' + s.dose + ' lb per cu ft', fmt(s.grains) + ' grains'],
      ['Water to drain a month', s.waterMonth != null ? fmt(s.waterMonth) + ' gal' : 'n/a'],
      ['Pressure drop at your peak', fmt1(s.pressureDrop) + ' psi'],
      ['Rated flow', s.printed],
      ['Tank', s.tank],
      ['Rated capacity', fmt(s.rated) + ' grains']
    ].map(([t, v]) => '<dt>' + esc(t) + '</dt><dd>' + esc(v) + '</dd>').join('');
    setText(f('price'), item ? money(item.variant.price) : '', true);
    const img = item && (item.variant.image || item.product.image);
    const media = el.querySelector('.cqss-card-media');
    let im = media.querySelector('img');
    if (img && (!im || im.getAttribute('src') !== img)) {
      if (!im) { im = document.createElement('img'); im.alt = item.product.title; im.width = 700; im.height = 700; im.loading = 'lazy'; im.crossOrigin = 'anonymous'; media.appendChild(im); }
      im.removeAttribute('srcset'); im.src = img;
      ground(im);
    }
    // one action per card: the match buys (when the drawer sells the same item), the others become the match
    const btnWrap = f('btn');
    const sameItem = isPick && (c.setupKey === 'softener' || s.kind === 'com' || !c.setups.length);
    const want = ruled ? 'ruled' : isPick ? (sameItem && item ? 'add' : 'drawer') : 'choose';
    if (btnWrap.dataset.mode !== want || btnWrap.tagName === 'A') {
      const span = document.createElement('span');
      span.dataset.cqssF = 'btn'; span.dataset.mode = want;
      span.innerHTML = want === 'ruled' ? '<button type="button" class="cqv-btn cqv-btn-ghost" disabled>Not a fit</button>'
        : want === 'add' ? '<button type="button" class="cqv-btn" data-cqss-add>Add to cart</button>'
        : want === 'drawer' ? '<button type="button" class="cqv-btn" data-cqss-do="to-drawer">See your setup</button>'
        : want === 'specialist' ? '<button type="button" class="cqv-btn" data-cqss-do="specialist">Talk to a specialist</button>'
        : '<button type="button" class="cqv-btn cqv-btn-ghost" data-cqss-choose="' + s.key + '">Choose ' + esc(sizeNum(s)) + ' cu ft</button>';
      btnWrap.replaceWith(span);
    }
    if (want === 'add' && item) { const a = el.querySelector('[data-cqss-add]'); a.disabled = !item.variant.available; a.textContent = item.variant.available ? 'Add to cart' : 'Sold out'; }
  }
  // why a size is greyed out, in the card label
  function ruledWhy(s, r) {
    if (s.flowFit === 'no') return r.preference === 'pressure' && r.flow.peak <= s.comfort ? 'Pressure dips too far at peak' : 'Not enough flow for your home';
    return s.capFit === 'no' ? 'Too small for your home' : 'Not a fit for your water';
  }
  // AJ 2026-10-15 18:17 ("doesnt shift when clicking tabs"): a priority click changes what is in the cards, never which
  // cards there are or how tall they are. The cards are every size any priority would show, each label holds the room
  // of its wording under every priority, and the pressure flag line is held while any priority would raise it.
  function steadyCards(r, c) {
    const all = Object.keys(S.PREFS).map(k => k === r.preference ? r : S.compute(Object.assign({}, state, {preference: k}))).filter(o => o.ready);
    const keys = new Set([c.size.key]);
    all.forEach(o => o.shown.forEach(k => keys.add(k)));
    const sizes = r.sizes.filter(s => keys.has(s.key));
    const labels = new Map(sizes.map(s => [s.key, [...new Set(all.map(o => cardLabel(o.sizes.find(z => z.key === s.key), o, o.pick)))]]));
    return {sizes, labels, flag: all.some(o => o.sizes.some(s => keys.has(s.key) && s.flowFit === 'tight'))};
  }
  function renderCards(r, c) {
    if (!r.ready) return;
    const capnote = $('[data-cqss-capnote]');
    if (capnote) capnote.hidden = !isBeyond();   // G4 12: the cards are drawn at the engine's 150 gpg cap
    const steady = steadyCards(r, c), list = steady.sizes;
    // First: where every card is now
    const first = new Map();
    cards.forEach((el, k) => { if (el.isConnected) first.set(k, el.getBoundingClientRect()); });
    list.forEach(s => { const el = cards.get(s.key) || makeCard(s); fillCard(el, s, r, c, steady.labels.get(s.key)); cardsEl.appendChild(el); });
    cards.forEach((el, k) => { if (!list.some(s => s.key === k) && el.isConnected) el.remove(); });
    cardsEl.dataset.count = String(list.length);
    cardsEl.style.setProperty('--cols', String(Math.max(1, list.length)));
    cardsEl.classList.toggle('has-flag', steady.flag);
    // Last, Invert, Play
    if (calm()) return;
    list.forEach((s, i) => {
      const el = cards.get(s.key), was = first.get(s.key);
      if (was) {
        const now = el.getBoundingClientRect(), dx = was.left - now.left, dy = was.top - now.top;
        if (Math.abs(dx) > 1 || Math.abs(dy) > 1) el.animate([{transform: 'translate(' + dx + 'px,' + dy + 'px)'}, {transform: 'none'}], {duration: 360, easing: 'cubic-bezier(.22,.9,.24,1)'});
      } else el.animate([{opacity: 0, transform: 'translateY(12px)'}, {opacity: 1, transform: 'none'}], {duration: 320, delay: Math.min(i, 3) * 40, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'backwards'});
    });
  }
  // a size card's button mid-run ends the run first (G4 10), then does what it does today
  cardsEl.addEventListener('click', e => { if (guide.on() && e.target.closest('button, a')) guide.finish('card'); }, true);
  cardsEl.addEventListener('click', e => {
    const b = e.target.closest('[data-cqss-choose]');
    if (!b) return;
    state.choice = b.dataset.cqssChoose === (result && result.pick) ? null : b.dataset.cqssChoose;
    state.setup = null;
    track('cq_quiz_answer', {screen: 'size-choice', value: b.dataset.cqssChoose});
    render();
    const btn = cardsEl.querySelector('[data-cqss-card="' + b.dataset.cqssChoose + '"] .cqss-card-foot .cqv-btn');
    if (btn) btn.focus({preventScroll: true});
  });
  pref.addEventListener('click', e => {
    const b = e.target.closest('button');
    if (!b) return;
    // the buttons stay under the pointer: a note above them can come or go with the priority, so the page scrolls by
    // exactly that much before it paints (AJ 2026-10-15 18:17)
    const hold = !guide.on(), was = b.getBoundingClientRect().top;
    if (guide.on()) guide.finish('priority');
    state.preference = b.value; state.choice = null;
    setPressed(pref, b.value);
    track('cq_quiz_answer', {screen: 'priority', value: b.value});
    changed('priority');
    const moved = b.getBoundingClientRect().top - was;
    if (hold && Math.abs(moved) >= 1) window.scrollBy(0, moved);
  });
  // arrow keys move within the priority radio group
  pref.addEventListener('keydown', e => {
    if (!/^Arrow(Left|Right)$/.test(e.key)) return;
    const bs = $$('button', pref), i = bs.indexOf(document.activeElement);
    if (i < 0) return;
    const n = bs[(i + (e.key === 'ArrowRight' ? 1 : bs.length - 1)) % bs.length];
    n.focus(); n.click(); e.preventDefault();
  });

  /* ------------------------------------------------------------------ phone result bar */
  function renderDock(r, c) {
    if (!dock) return;
    // one short line each, so the bar keeps its height whatever the size: the days sit on the small line (AJ 10-16)
    const lab = $('[data-cqss-dock-text] span'), t = $('[data-cqss-dock-text] b');
    if (!r.ready) { setText(lab, 'Your size', true); setText(t, 'Enter your hardness', true); dock.classList.remove('is-in'); return; }
    const sized = !isBeyond() && !isSoft(r);
    setText(lab, sized ? 'Your size, ' + (c.size.timer > 0 ? daysText(c.size.timer) : 'regenerates daily') : 'Your size', true);
    setText(t, isBeyond() ? 'Sized by a specialist' : isSoft(r) ? 'Already soft' : sizeName(c.size));
  }

  /* Product photo tiles take their ground from the photo's own edge (the theme's cq-media-ground.js does this on
     product pages), so a studio photo never shows a box inside the tile: an even light grey edge becomes the tile
     colour, an even white edge multiplies into it, anything else keeps the default tile. Cosmetic and cached. */
  const grounds = {};
  function ground(img) {
    const tile = img.parentElement;
    const apply = g => { if (!g || !tile) return; tile.style.setProperty('--cqss-ground', g.color); tile.dataset.cqssGround = g.kind; };
    // Cache only a real reading: WebKit can report a swapped image as complete before the new file decodes, and a
    // blank sample cached as "no ground" left the default tile showing a lighter square around a grey studio photo.
    if (grounds[img.currentSrc || img.src]) { apply(grounds[img.currentSrc || img.src]); return; }
    const run = () => {
      try {
        const c = document.createElement('canvas'); c.width = c.height = 16;
        const x = c.getContext('2d', {willReadFrequently: true});
        x.drawImage(img, 0, 0, 16, 16);
        const d = x.getImageData(0, 0, 16, 16).data;
        const px = [0, 8, 15, 128, 143, 240, 248, 255].map(i => [d[i * 4], d[i * 4 + 1], d[i * 4 + 2]]);
        const avg = [0, 1, 2].map(k => px.reduce((a, p) => a + p[k], 0) / px.length);
        const even = px.every(p => Math.abs(p[0] - avg[0]) < 10 && Math.abs(p[1] - avg[1]) < 10 && Math.abs(p[2] - avg[2]) < 10);
        const grey = Math.abs(avg[0] - avg[1]) < 8 && Math.abs(avg[1] - avg[2]) < 8;
        let g = null;
        if (even && grey && avg[0] > 248) g = {kind: 'white', color: '#fff'};
        else if (even && grey && avg[0] > 200) g = {kind: 'grey', color: 'rgb(' + avg.map(Math.round).join(',') + ')'};
        if (g) grounds[img.currentSrc || img.src] = g;
        apply(g);
      } catch (_) { /* cross-origin or not decoded: keep the default tile */ }
    };
    if (img.complete && img.naturalWidth) run();
    img.addEventListener('load', run, {once: true});
  }

  /* ------------------------------------------------------------------ render */
  // A gpg figure above 60 is almost always mg/L typed into the gpg box (342 mg/L is 20 gpg): ask before sizing on it,
  // so nobody is shown a 15 cu ft commercial system by a unit slip (AJ 2026-10-15 02:21, "wtf happened here").
  // keptGpg / keptMgl hold a figure the visitor confirmed in its unit; the share URL carries them as kg=1 / km=1.
  let keptGpg = null, keptMgl = null;
  const isSlip = () => state.unit === 'gpg' && parseFloat(state.hardness) > 60 && keptGpg !== String(state.hardness);
  // G4 4.1 check variant B: an mg/L figure above 0 and under 20 is probably gpg
  const isLowMgl = () => { const v = parseFloat(state.hardness); return state.unit === 'mgl' && v > 0 && v < 20 && keptMgl !== String(state.hardness); };
  // G4 12: past what the engine sizes (it caps at 150 gpg); never while a unit check is pending
  const isBeyond = () => { const g = S.toGpg(state.hardness, state.unit); return g != null && g > 150 && !isSlip(); };
  const kept = () => (state.unit === 'gpg' && keptGpg != null && keptGpg === String(state.hardness)) || (state.unit === 'mgl' && keptMgl != null && keptMgl === String(state.hardness));
  const BIG_CUFT = 7;
  const isBig = s => s && s.kind === 'com' && s.cuft >= BIG_CUFT;
  const resultH = $('[data-cqss-result-h]');
  const AHEAD = {metal: 'a Metal Removal filter', tannin: 'a tannin system', neutralizer: 'an acid neutralizer', nitrate: 'a nitrate system'};
  const everyDays = n => n > 1 ? 'every ' + Math.min(14, n) + '\u00a0days' : 'every\u00a0day';
  /* The pane's hidden h2 (G4 5.6 row 1, 15): the whole result in one sentence. Focus lands here at See my size, so a
     screen reader hears the finished result at once; while it holds a result, the visible kicker, size and line say
     the same words and are aria-hidden. */
  function resultSentence(r, c) {
    if (!r || !r.ready || !c) return 'Your result';
    if (isBeyond()) return 'We size up to 150 gpg. Your water is harder, so a specialist confirms the size.';
    if (isSoft(r)) return 'Your water is already soft. You may not need a salt-based softener.';
    const s = c.size, tail = 'regenerates ' + everyDays(s.timer) + (s.saltMonth != null ? ', on about ' + fmt(s.saltMonth) + '\u00a0lb of ' + (r.kcl ? 'potassium' : 'salt') + ' a month.' : '.');
    if (state.choice && state.choice !== r.pick) return 'Your choice: the ' + sizeName(s) + '. It ' + tail;
    const ahead = r.ahead.map(k => AHEAD[k]).filter(Boolean);
    if (ahead.length) return 'We recommend the ' + sizeName(s) + ' softener with ' + ahead.join(' and ') + ' ahead of it. The softener ' + tail;
    return 'We recommend the ' + sizeName(s) + ' softener. It ' + tail;
  }
  function paintHeading(r, c) {
    const ready = !guide.on() && !!(r && r.ready && c);
    if (resultH) resultH.textContent = ready ? resultSentence(r, c) : 'Your result';
    [$('.cqss-pane > .cqss-kicker'), P.size, P.sub].forEach(n => { if (!n) return; if (ready) n.setAttribute('aria-hidden', 'true'); else n.removeAttribute('aria-hidden'); });
  }
  // G4 17.2 render: always read the form and compute (so the result is ready the moment the run ends); draw the pane,
  // notes, cards and dock only outside the guided run, which paints its own waiting pane instead
  function render() {
    readForm();
    result = S.compute(Object.assign({}, state));
    if (result.ready && isSlip()) result = Object.assign({}, result, {ready: false, slip: true});
    const c = result.ready ? chosen(result) : null;
    paintHeading(result, c);
    if (guide.on()) {
      guide.paintWait(result);
    } else {
      renderPane(result, c);
      renderNotes(result, c);
      renderCards(result, c);
      renderDock(result, c);
      guide.recap();
    }
    validate();
    syncDock();
    return c;
  }

  /* validation messages under the hardness field (calculator only: each guided screen checks its own answer) */
  function validate() {
    if (guide.on()) return;
    const box = $('[data-cqss-hardbox]'), err = $('#cqss-hard-error');
    const v = parseFloat(state.hardness);
    let msg = '', info = false;
    if (state.hardness && v < 0) msg = 'Hardness cannot be below zero.';
    else if (state.hardness && !(v >= 0)) msg = 'Enter hardness as a number.';
    else if (isLowMgl()) msg = 'That is very soft for mg/L. Is it grains per gallon? <button type="button" class="cqv-text-btn" data-cqss-do="unit-gpg">Switch to gpg</button> <button type="button" class="cqv-text-btn" data-cqss-do="keep-mgl">Keep mg/L</button>';
    else if (isSlip()) msg = 'That is very high for grains per gallon. Is it mg/L? <button type="button" class="cqv-text-btn" data-cqss-do="unit-mgl">Switch to mg/L</button>';
    else if (S.C.UNITS[state.unit] && v > S.C.UNITS[state.unit].max) { msg = 'We size up to 150 gpg. You\'ll still see a size, and a specialist confirms it.'; info = true; }   // G4 5.11: information, not an error
    box.classList.toggle('is-error', !!msg && !info && !(state.unit === 'gpg' && v > 60 && v <= 150));
    err.classList.toggle('is-info', info);
    const was = err.hidden;
    if (err.innerHTML !== msg) err.innerHTML = msg;
    err.hidden = !msg;
    if (msg && was) appear(err);
  }

  /* change handling: render now, speak and report once the visitor pauses */
  let reportTimer = null, lastReported = '', sayTimer = null, lastSaid = '';
  const sayEl = $('[data-cqss-announce]');
  // G4 5.11 announcements (the pane's polite region, 900 ms after typing stops)
  function announceText() {
    if (!result || !result.ready) return '';
    if (isBeyond()) return 'We size up to 150 gpg. A specialist confirms the size for your water.';
    if (isSoft(result)) return 'Your water is already soft. You may not need a salt-based softener.';
    const s = chosen(result).size;
    if (state.choice && state.choice !== result.pick) return 'Your choice: the ' + sizeName(s) + '. It regenerates ' + everyDays(s.timer) + '.';
    return 'We recommend the ' + sizeName(s) + ' softener. It regenerates ' + everyDays(s.timer) +
      (s.saltMonth != null ? ', on about ' + fmt(s.saltMonth) + ' pounds of ' + (result.kcl ? 'potassium' : 'salt') + ' a month' : '') + '.';
  }
  function announce() {
    clearTimeout(sayTimer);
    sayTimer = setTimeout(() => {
      if (!sayEl) return;
      const t = announceText();
      if (t !== lastSaid) { lastSaid = t; sayEl.textContent = t; }
    }, 900);
  }
  // say a line in the pane's region now (the guide's own region is hidden once the run ends)
  function sayNow(t) {
    if (!sayEl || !t) return;
    clearTimeout(sayTimer); lastSaid = t; sayEl.textContent = '';
    later(() => { sayEl.textContent = t; }, 40);
  }
  const reportKey = c => [result.pick, c && c.size.key, result.preference, result.water.band.key].join('|');
  // today's result_view payload (J768 to J772, bands and IDs only) plus G4 16's mode, check and beyond
  function resultPayload(c, mode) {
    const r = result;
    return {outcome: r.pick, chosen: c && c.size.key, priority: r.preference, band: r.water.band.key, source: r.water.source,
      people: r.demand.people > 6 ? '7+' : r.demand.people > 4 ? '5-6' : r.demand.people > 2 ? '3-4' : '1-2', ahead: r.ahead.join(',') || 'none',
      mode, check: guide.checkState(), beyond: isBeyond()};
  }
  function changed(why) {
    if (guide.on()) {
      // G4 17.2: during the run an answer only re-computes and repaints the waiting pane; no URL, no result events
      if (!started) { started = true; track('cq_quiz_start', {screen: guide.step(), via: 'answer'}); }
      render(); guide.sync(); guide.save();
      return;
    }
    if (!started) { started = true; track('cq_quiz_start', why === 'url' ? {screen: 'url', via: 'url'} : {screen: why.split(':')[0], via: 'answer'}); }
    guide.touch(why);
    const c = render();
    announce();
    followChart();
    clearTimeout(reportTimer);
    if (!result.ready) { writeUrl(); return; }
    reportSoon(c);
    writeUrl();
  }
  // a calculator result view after a 1.5 s pause, once per distinct result (today's debounce and key, J768 to J772)
  function reportSoon(c) {
    clearTimeout(reportTimer);
    reportTimer = setTimeout(() => {
      if (!result || !result.ready) return;
      const key = reportKey(c);
      if (key === lastReported) return;
      lastReported = key;
      track('cq_quiz_result_view', resultPayload(c, 'calc'));
    }, 1500);
  }

  /* ================================================================== guided first run (G4 sections 4 to 11, 14 to 16)
     A view over the form. It owns where the visitor is (the step, the answered screens, how the hardness is being
     given) and never an answer: screens are cloned from <template data-cqss-screens>, painted from `state`, and every
     answer goes through setSeg, setFlag, setSign or setField. One question at a time, no history entries, the tab's
     sessionStorage (one codec with the share URL) for a reload, then a short sizing moment and the live calculator. */
  const guide = (() => {
    const allowed = root.hasAttribute('data-cqss-guided');
    const el = $('[data-cqss-guide]');
    const stage = el && $('[data-cqss-stage]', el);
    const tpl = el && $('template[data-cqss-screens]', el);
    const bar = el && $('.cqv-q-progress', el);
    const backBtn = el && $('[data-cqss-do="g-back"]', el);
    const sayG = el && $('[data-cqss-guide-say]', el);
    const recapEl = $('[data-cqss-recap]');
    const recapLineEl = $('[data-cqss-recap-line]');
    const changeBtn = $('[data-cqss-do="g-change"]');
    const formBody = $('#cqss-form-body');
    const calcBand = $('#cqss-calc');
    const sizingEl = $('[data-cqss-sizing]');
    const waitList = $('[data-cqss-wait-list]'), waitCap = $('[data-cqss-wait-cap]'), waitTiles = $('[data-cqss-wait-tiles]'), waitWhy = $('[data-cqss-wait-why]');
    const scaleLis = $$('.cqss-scale li');
    const paneCopy = tpl && tpl.content ? tpl.content.querySelector('[data-cqss-copy="pane"]') : null;
    const KEY = 'cqss:v3';
    const ORDER = ['source', 'signs', 'hardness', 'zip', 'check', 'people', 'baths', 'style', 'extras'];
    const CH1 = ['source', 'signs', 'hardness', 'zip', 'check'];
    const TEST = ['iron', 'manganese', 'ph'];
    const BANDS = ['soft', 'slight', 'moderate', 'hard', 'very'];
    const UNIT_WORD = {gpg: 'gpg', mgl: 'mg/L', dh: 'German degrees', fh: 'French degrees', mmol: 'mmol/L'};
    const fresh = () => ({step: 'source', answered: new Set(), hardVia: 'number', gpgGiven: false, fill: {1: 0, 2: 0}, zip: '', zipHit: null,
      zipState: 'find', checked: null, peoplePick: null, played: false, ended: false, shown: false, touched: new Set(), rowsSig: null, rowKeys: new Set()});
    const G = Object.assign(fresh(), {seen: false, exitSent: false, pending: 0, sizing: null, booted: false});

    /* ---- small helpers */
    const on = () => root.getAttribute('data-cqss-mode') === 'guided';
    const chOf = id => CH1.includes(id) ? 1 : 2;
    const cur = () => stage ? stage.querySelector(':scope > .cqss-g-screen:not(.cqq-ghost)') : null;
    const tplScreen = id => tpl && tpl.content ? tpl.content.querySelector('[data-cqss-screen="' + id + '"]') : null;
    const rawHard = () => normNum(form.elements.hardness.value);
    const hardOk = raw => raw !== '' && isFinite(Number(raw)) && Number(raw) >= 0;
    const hardReason = raw => raw.charAt(0) === '-' && isFinite(Number(raw)) ? 'negative' : 'nan';
    const testReason = (k, raw) => { raw = normNum(raw); if (raw === '') return ''; const n = Number(raw); return !(isFinite(n) && n >= 0) ? 'nan' : k === 'ph' && n > 14 ? 'ph' : ''; };
    const isAnswered = id => G.answered.has(id) || (id === 'hardness' && G.answered.has('zip')) || (id === 'zip' && G.answered.has('hardness'));
    const enterMs = () => cssTimeMs(window.getComputedStyle(el).getPropertyValue('--cqq-enter-ms'), 320);
    const swapMs = () => cssTimeMs(window.getComputedStyle(el).getPropertyValue('--cqq-swap-ms'), 220);
    const focusEl = n => { if (!n) return; try { n.focus({preventScroll: true}); } catch (_) { n.focus(); } };
    const jump = dy => { if (!dy) return; try { window.scrollBy({top: dy, left: 0, behavior: 'instant'}); } catch (_) { window.scrollBy(0, dy); } };
    const store = v => { try { sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (_) { /* private mode: the run still works */ } };
    function load() { try { const s = JSON.parse(sessionStorage.getItem(KEY) || 'null'); return s && s.v === 1 ? s : null; } catch (_) { return null; } }
    function save() { if (on()) store({v: 1, step: G.step, answered: Array.from(G.answered), via: G.hardVia, q: encodeState()}); }
    // [data-cqss-v] spans take values from state, the result or the lookup
    function fill(node, vals) { $$('[data-cqss-v]', node).forEach(s => { const k = s.dataset.cqssV; if (vals && vals[k] != null) s.textContent = vals[k]; }); }
    // a message from a screen's (or the pane's) hidden copy block, filled, as plain text
    function msg(scope, key, vals) {
      const m = scope && scope.querySelector('[data-cqss-msg="' + key + '"]');
      if (!m) return '';
      const c = m.cloneNode(true); fill(c, vals);
      return c.textContent.replace(/\s+/g, ' ').trim();
    }
    const pmsg = (key, vals) => msg(paneCopy, key, vals);
    // [data-cqss-case] siblings: show the one that applies; `drop` removes the others from a fresh clone (whole variants)
    function setCase(parent, name, drop) {
      if (!parent) return;
      Array.from(parent.children).forEach(c => {
        if (!c.hasAttribute('data-cqss-case')) return;
        const yes = c.dataset.cqssCase === name;
        if (drop && !yes) c.remove(); else c.hidden = !yes;
      });
    }
    const chip = sel => { const c = $(sel); return c ? c.textContent.replace(/\s+/g, ' ').trim() : ''; };
    const signLabels = () => state.signs.map(k => chip('[data-cqss-sign="' + k + '"]')).filter(Boolean).join(', ');
    const extraLabels = () => ['hose', 'extraHeads', 'wfh'].filter(k => state[k]).map(k => chip('[data-cqss-flag="' + k + '"]')).filter(Boolean).join(', ');
    function styleWord() {
      const s = tplScreen('style'), b = s && s.querySelector('[data-cqss-pick="bathStyle:' + state.bathStyle + '"] .cqv-q-option-text > span');
      const t = b ? b.textContent.trim() : '';
      return t ? t.charAt(0).toLowerCase() + t.slice(1) : '';
    }

    /* ---- the path (G4 4.1) */
    // a likely unit slip: over 60 gpg, or an mg/L figure above 0 and under 20, not yet confirmed in its unit
    function needsCheck() {
      const raw = rawHard(), v = Number(raw), u = form.elements.unit.value;
      if (!hardOk(raw)) return false;
      return (u === 'gpg' && v > 60 && keptGpg !== raw) || (u === 'mgl' && v > 0 && v < 20 && keptMgl !== raw);
    }
    const path = () => ['source',
      state.source === 'well' && 'signs',
      !G.gpgGiven && (G.hardVia === 'zip' ? 'zip' : 'hardness'),
      needsCheck() && 'check',
      'people', 'baths',
      state.baths >= 2 && 'style',
      'extras'].filter(Boolean);
    // answers whose screen left the path are cleared during the run (well to city clears the signs and test numbers)
    function prune() {
      if (!on()) return false;
      const p = path();
      let did = false;
      if (!p.includes('signs')) {
        if (state.signs.length) { state.signs.slice().forEach(k => setSign(k, false, true)); did = true; }
        TEST.forEach(k => { if (form.elements[k].value) { form.elements[k].value = ''; did = true; } });
        G.answered.delete('signs');
      }
      if (!p.includes('style')) {
        if (state.bathStyle !== 'combo') { setSeg('bathStyle', 'combo', true); did = true; }
        G.answered.delete('style');
      }
      return did;
    }
    // never show a screen whose earlier questions are unanswered (family js:1391 to 1397)
    function firstGap(id) {
      const p = path();
      if (!p.includes(id)) id = p.find(x => !isAnswered(x)) || p[p.length - 1];
      const gap = p.slice(0, p.indexOf(id)).find(x => !isAnswered(x));
      return gap || id;
    }

    /* ---- painting a screen from state */
    function pressed(node, id) {
      const set = fn => $$('button.cqv-q-option[data-cqss-pick]', node).forEach(b => b.setAttribute('aria-pressed', String(!!fn(b.dataset.cqssPick.split(':')[1]))));
      if (id === 'source') set(v => G.answered.has('source') && (v === 'unsure' ? !state.source : state.source === v));
      else if (id === 'people') set(v => G.peoplePick === v);
      else if (id === 'baths') set(v => G.answered.has('baths') && +v === state.baths);
      else if (id === 'style') set(v => G.answered.has('style') && v === state.bathStyle);
      else if (id === 'check') set(() => false);
      $$('input[type="checkbox"][data-cqss-pick]', node).forEach(i => {
        const [k, v] = i.dataset.cqssPick.split(':');
        if (k === 'signs') i.checked = state.signs.includes(v);
        else if (k === 'flag') i.checked = v === 'extraHeads' ? !!state.extraHeads : !!state[v];
      });
    }
    // labels that change while a screen shows: the signs primary (None of these / Continue), the hardness Continue
    function primaryCase(node, id) {
      if (id === 'signs') {
        const b = node.querySelector('[data-cqss-do="g-next"]');
        setCase(b, state.signs.length || TEST.some(k => form.elements[k].value) ? 'some' : 'empty');
      } else if (id === 'hardness') {
        const b = node.querySelector('.cqss-g-act [data-cqss-do="g-next"]'), f = node.querySelector('[data-cqss-g-field="hardness"]');
        if (b && f) b.setAttribute('aria-disabled', String(!hardOk(normNum(f.value))));
      }
    }
    function paintUnits(node, animate) {
      const u = form.elements.unit.value, other = u !== 'gpg' && u !== 'mgl';
      $$('.cqv-q-units button', node).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.cqssPick === 'unit:' + (other ? 'other' : u))));
      const box = node.querySelector('[data-cqss-g-other]'), sel = node.querySelector('[data-cqss-g-field="unit-other"]');
      if (other && sel) sel.value = u;
      if (box && box.hidden === other) { if (animate) openBox(box, other); else box.hidden = !other; }
    }
    // the live line under the hardness field: the visitor's band once the value parses (G4 5.3 hardness)
    function hardLive(node) {
      const f = node.querySelector('[data-cqss-g-field="hardness"]'), live = node.querySelector('[data-cqss-g-live]');
      if (!f || !live) return;
      const raw = normNum(f.value), u = form.elements.unit.value, U = S.C.UNITS[u] || S.C.UNITS.gpg;
      let t = '';
      if (hardOk(raw)) {
        const v = Number(raw), g = S.toGpg(v, u), band = S.band(Math.min(g, 150)).label.toLowerCase();
        t = v > U.max ? msg(node, 'live-max') : u === 'gpg' ? msg(node, 'live-gpg', {v: trimNum(v), band}) : msg(node, 'live-conv', {v: trimNum(v), unit: UNIT_WORD[u] || u, g: fmt1(g), band});
      }
      const was = live.hidden;
      if (live.textContent !== t) live.textContent = t;
      live.hidden = !t;
      if (t && was) appear(live);
    }
    function paintInto(node, id) {
      const q = s => node.querySelector(s);
      if (id === 'hardness') {
        setCase(q('.cqv-q-lead'), state.source === 'well' ? 'well' : 'city', true);
        q('[data-cqss-g-field="hardness"]').value = form.elements.hardness.value;
        paintUnits(node, false);
        hardLive(node);
      } else if (id === 'zip') {
        setCase(q('.cqv-q-lead'), state.source === 'well' ? 'well' : 'default', true);
        q('[data-cqss-g-field="zip"]').value = G.zip;
        zipPaint(node);
      } else if (id === 'check') {
        const v = Number(rawHard()), k = form.elements.unit.value === 'gpg' ? 'a' : 'b';
        setCase(q('.cqv-q-title'), k, true); setCase(q('.cqv-q-lead'), k, true); setCase(node, k, true);
        if (k === 'a') { const help = q('[data-cqss-pick="check:gpg"] .cqv-q-option-help'); if (help) setCase(help, v > 150 ? 'beyond' : 'hard', true); }
        fill(node, {v: trimNum(v), g: fmt1(S.toGpg(v, 'mgl'))});
      } else if (id === 'signs') {
        TEST.forEach(k => { const f = q('[data-cqss-g-field="' + k + '"]'); if (f) f.value = form.elements[k].value; });
        if (TEST.some(k => form.elements[k].value)) { q('.cqss-g-test-body').hidden = false; q('[data-cqss-do="g-test"]').setAttribute('aria-expanded', 'true'); }
      } else if (id === 'people') {
        const six = G.peoplePick === '6plus';
        q('[data-cqss-g-more]').hidden = !six;
        if (six) q('[data-cqss-g-field="people"]').value = Math.max(6, state.people);
      }
      pressed(node, id);
      primaryCase(node, id);
    }
    function paint(id) {
      const src = tplScreen(id);
      if (!src) return null;
      const node = src.cloneNode(true);
      paintInto(node, id);
      return node;
    }

    /* ---- progress, chrome and the polite line (G4 5.2) */
    // two segments; a chapter fills by its screens behind the current one on the path; forward never shrinks it
    // (family js:753 to 768)
    function paintProgress(dir) {
      if (!bar) return;
      const p = path(), ch = chOf(G.step), inCh = p.filter(id => chOf(id) === ch), i = Math.max(0, inCh.indexOf(G.step));
      let f = inCh.length ? Math.round(i / inCh.length * 100) : 0;
      if (dir !== -1) f = Math.max(f, G.fill[ch] || 0);
      G.fill[ch] = f;
      const fills = ch === 1 ? [f, 0] : [100, f];
      Array.from(bar.children).forEach((s, k) => { s.classList.toggle('is-done', fills[k] >= 100); s.style.setProperty('--cqv-q-fill', fills[k] + '%'); });
      bar.setAttribute('aria-valuenow', String(Math.round((fills[0] + fills[1]) / 2)));
      const t = pmsg('progress-' + ch); if (t) bar.setAttribute('aria-valuetext', t);
    }
    function sync() {
      if (!on() || !el) return;
      if (backBtn) backBtn.hidden = path()[0] === G.step;
      el.setAttribute('aria-labelledby', 'cqss-q-' + G.step);
      const node = cur(); if (node) primaryCase(node, G.step);
      paintProgress(0);
    }
    function say(t) { if (!sayG || !t) return; sayG.textContent = ''; later(() => { sayG.textContent = t; }, 40); }
    // the card's top never sits above the sticky header after a change: scroll it to y 88, never down (G4 6.2)
    function keepTop() { if (!el) return; const top = el.getBoundingClientRect().top; if (top < 88) jump(top - 88); }

    /* ---- moving between screens (G4 7, 15): the outgoing screen freezes as a ghost (family js:960 to 968), focus moves
       to the new question under it, the new screen rises, its question reveals word by word */
    function ghost(old) {
      old.classList.remove('is-entering'); old.classList.add('cqq-ghost');
      old.setAttribute('aria-hidden', 'true'); old.setAttribute('inert', ''); old.inert = true;
      $$('[id]', old).forEach(n => n.removeAttribute('id'));
      return old;
    }
    function tween(before) {
      if (!el || calm()) return;
      const after = el.getBoundingClientRect().height;
      if (Math.abs(after - before) > 1) el.animate([{height: before + 'px'}, {height: after + 'px'}], {duration: 320, easing: GLIDE});
    }
    function go(id, opts) {
      opts = opts || {};
      const node = stage && paint(id);
      if (!node) return;
      clearTimeout(G.pending);
      finishWords();
      const animate = !calm() && !opts.instant;
      const before = el.getBoundingClientRect().height;
      const fromCh = chOf(G.step), old = cur();
      $$(':scope > .cqq-ghost', stage).forEach(g => g.remove());
      let gh = null;
      if (old) { if (animate) gh = ghost(old); else old.remove(); }
      stage.appendChild(node);
      G.step = id;
      root.setAttribute('data-cqss-step', id);
      if (opts.focus !== false) focusEl(node.querySelector('.cqv-q-title'));
      paintProgress(opts.dir);
      sync();
      if (animate) {
        node.classList.add('is-entering');
        later(() => node.classList.remove('is-entering'), enterMs() + 60);
        words(node.querySelector('.cqv-q-title'));
        if (gh) { void window.getComputedStyle(gh).opacity; gh.classList.add('is-out'); later(() => gh.remove(), swapMs() + 60); }
        tween(before);
      }
      if (opts.dir !== -1 && fromCh === 1 && chOf(id) === 2) say(pmsg('say-chapter'));
      if (opts.scroll !== false) keepTop();
      G.seen = true;
      track('cq_quiz_screen_view', {screen: id, chapter: chOf(id), mode: 'guided'});
      paintWait(result);
      save();
    }
    function next() {
      clearTimeout(G.pending);
      const i = ORDER.indexOf(G.step), nxt = path().find(id => ORDER.indexOf(id) > i);
      if (nxt) go(nxt, {dir: 1}); else showResult('guided');
    }
    function back() {
      clearTimeout(G.pending);
      let prev;
      // the number and ZIP screens are one question, so Back from either goes to the question before it
      const onHard = G.step === 'zip' || G.step === 'hardness', i = ORDER.indexOf(G.step === 'zip' ? 'hardness' : G.step);
      prev = path().filter(id => ORDER.indexOf(id) < i && !(onHard && (id === 'zip' || id === 'hardness'))).pop();
      if (!prev) return;
      track('cq_quiz_back', {from: G.step});
      go(prev, {dir: -1});
    }
    const mark = id => G.answered.add(id);
    const answerValue = (key, v) => (key === 'people' && v === '6plus') || (key === 'baths' && v === '6') ? '6+' : v;

    /* ---- answers */
    function pick(key, value, input) {
      clearTimeout(G.pending);
      const node = cur(), screen = G.step;
      let advance = true;
      if (key === 'source') { setSeg('source', value === 'unsure' ? null : value, true); mark('source'); }
      else if (key === 'signs') { setSign(value, !!(input && input.checked), true); advance = false; }
      else if (key === 'flag') { setFlag(value, !!(input && input.checked), true); advance = false; }
      else if (key === 'unit') { unitPick(value); return; }
      else if (key === 'check') { checkAnswer(value); mark('check'); }
      else if (key === 'people') {
        if (value === '6plus') {
          G.peoplePick = '6plus'; advance = false;
          setField('people', Math.max(6, state.people), true);
          const f = node && node.querySelector('[data-cqss-g-field="people"]'); if (f) f.value = Math.max(6, parseInt(form.elements.people.value, 10) || 6);
          openBox(node && node.querySelector('[data-cqss-g-more]'), true);
        } else {
          G.peoplePick = value; mark('people');
          setField('people', value, true);
          openBox(node && node.querySelector('[data-cqss-g-more]'), false);
        }
      }
      else if (key === 'baths') { setSeg('baths', value, true); if (+value === 1) setSeg('bathStyle', 'combo', true); mark('baths'); }
      else if (key === 'bathStyle') { setSeg('bathStyle', value, true); mark('style'); }
      else return;
      if (node) { pressed(node, screen); primaryCase(node, screen); }
      prune();
      changed(key === 'flag' ? 'flag:' + value : key === 'signs' ? 'sign:' + value : key === 'people' ? 'people' : 'seg:' + key);
      if (advance) {
        track('cq_quiz_answer', {screen, value: answerValue(key, value)});
        G.pending = later(next, calm() ? 0 : 140);       // a short beat on the chosen row; a second tap restarts it
      }
    }
    // a field shows its error line (role=alert) and is marked invalid; '' clears it
    function fieldError(f, text) {
      const e = f && f.id ? document.getElementById(f.id + '-err') : null;
      if (!e) return;
      const was = e.hidden;
      if (e.textContent !== text) e.textContent = text;
      e.hidden = !text;
      if (text) f.setAttribute('aria-invalid', 'true'); else f.removeAttribute('aria-invalid');
      const wrap = f.closest('.cqv-q-field'); if (wrap) wrap.classList.toggle('is-invalid', !!text);
      const box = f.closest('.cqss-box'); if (box) box.classList.toggle('is-error', !!text);
      if (text && was) appear(e);
    }
    // a Continue that is not ready explains itself: the message, a shake, focus back to the field (inside the tap)
    function invalid(f, reason, btn) {
      if (reason) track('cq_quiz_input_invalid', {screen: G.step, reason});
      nudge(btn);
      focusEl(f);
    }
    function cont(btn) {
      const node = cur(), id = G.step;
      if (!node) return;
      if (id === 'signs') {
        let bad = null;
        TEST.forEach(k => {
          const f = node.querySelector('[data-cqss-g-field="' + k + '"]'), r = f ? testReason(k, f.value) : '';
          if (f) fieldError(f, r ? msg(node, r) : '');
          if (r && !bad) bad = f;
        });
        if (bad) { openBox(node.querySelector('.cqss-g-test-body'), true); invalid(bad, 'test-range', btn); return; }
        mark('signs');
        track('cq_quiz_answer', {screen: 'signs', value: state.signs.join('.') || 'none'});
        next();
      } else if (id === 'hardness') {
        const f = node.querySelector('[data-cqss-g-field="hardness"]'), raw = normNum(f.value);
        if (!hardOk(raw)) { const r = hardReason(raw); fieldError(f, msg(node, r)); invalid(f, r, btn); return; }
        fieldError(f, '');
        if (f.value !== form.elements.hardness.value) setField('hardness', f.value, true);
        mark('hardness'); G.hardVia = 'number';
        const u = form.elements.unit.value, g = S.toGpg(Number(raw), u);
        track('cq_quiz_answer', {screen: 'hardness', entered: true, band: S.band(Math.min(g, 150)).key, unit: u});
        changed('input:hardness');
        next();
      } else if (id === 'people') {
        const f = node.querySelector('[data-cqss-g-field="people"]'), n = Number(normNum(f.value));
        if (!(Number.isInteger(n) && n >= 6 && n <= 40)) { fieldError(f, msg(node, 'range')); invalid(f, 'people-range', btn); return; }
        fieldError(f, '');
        G.peoplePick = '6plus'; mark('people');
        setField('people', n, true);
        track('cq_quiz_answer', {screen: 'people', value: '6+'});
        changed('people');
        next();
      }
    }
    function see() {
      mark('extras');
      track('cq_quiz_answer', {screen: 'extras', value: ['hose', 'extraHeads', 'wfh'].filter(k => state[k]).join('.') || 'none'});
      showResult('guided');
    }
    // the unit check (G4 5.3 check): a confirmed figure is kept in its unit; a correction switches the unit
    function checkAnswer(v) {
      const raw = rawHard(), gpgVariant = form.elements.unit.value === 'gpg';
      if (gpgVariant) { if (v === 'mgl') { setField('unit', 'mgl', true); G.checked = 'mgl'; } else { keptGpg = raw; G.checked = 'kept'; } }
      else if (v === 'gpg') { setField('unit', 'gpg', true); G.checked = 'gpg'; } else { keptMgl = raw; G.checked = 'kept'; }
    }
    function unitPick(v) {
      const node = cur();
      if (!node) return;
      const sel = node.querySelector('[data-cqss-g-field="unit-other"]');
      setField('unit', v === 'other' ? (sel ? sel.value : 'dh') : v, true);
      G.checked = null;
      paintUnits(node, true); hardLive(node); primaryCase(node, 'hardness');
      changed('unit');
    }
    function stepPeople(d) {
      const node = cur(), f = node && node.querySelector('[data-cqss-g-field="people"]');
      if (!f) return;
      const n = Math.min(40, Math.max(6, (parseInt(normNum(f.value), 10) || 6) + d));
      f.value = n; fieldError(f, '');
      if (!calm()) f.animate([{opacity: .3, transform: 'translateY(' + (d > 0 ? 6 : -6) + 'px)'}, {opacity: 1, transform: 'none'}], {duration: 180, easing: EASE});
      setField('people', n);
    }
    // the test fields, the "6 or more" stepper and the other units open like the page's accordions (J94: 320 / 240 ms)
    function openBox(box, open) {
      if (!box || box.hidden === !open) return;
      if (calm()) { box.hidden = !open; return; }
      const keep = box.style.overflow, done = () => { box.style.overflow = keep; };
      box.style.overflow = 'hidden';
      if (open) {
        box.hidden = false;
        const h = box.scrollHeight;
        box.animate([{height: '0px', opacity: 0}, {height: h + 'px', opacity: 1}], {duration: 320, easing: GLIDE}).finished.then(done, done);
      } else {
        const h = box.getBoundingClientRect().height;
        const end = () => { box.hidden = true; done(); };
        box.animate([{height: h + 'px', opacity: 1}, {height: '0px', opacity: 0}], {duration: 240, easing: 'cubic-bezier(.4,0,1,1)'}).finished.then(end, end);
      }
    }
    function toggleTest() {
      const node = cur(), b = node && node.querySelector('[data-cqss-do="g-test"]'), body = node && node.querySelector('.cqss-g-test-body');
      if (!b || !body) return;
      const open = body.hidden;
      b.setAttribute('aria-expanded', String(open));
      openBox(body, open);
    }

    /* ---- ZIP (G4 5.3 zip): never advances by itself; the ZIP stays in this tab's memory only */
    function zipPaint(node, busy) {
      const h = G.zipHit, btn = node.querySelector('[data-cqss-do="g-zip-find"]'), box = node.querySelector('[data-cqss-g-found]');
      // a private well gets the same lookup, always worded as an area estimate to confirm with a test
      const well = state.source === 'well';
      const c = busy ? 'busy' : !h ? 'find' : h.match === 'exact' ? (well ? 'near' : 'use') : h.match === 'near' ? 'near' : 'estimate';
      G.zipState = c;
      if (btn) {
        if (busy) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
        if (h && h.gpg != null) fill(btn, {g: fmt1(h.gpg)});
        setCase(btn, c);
      }
      if (busy || !box) return;
      const vals = h && h.gpg != null ? {g: fmt1(h.gpg), city: h.city, ppm: fmt(h.ppm), miles: fmt(h.miles)} : {zip: G.zip};
      const hit = !!h && (h.match === 'exact' || h.match === 'near');
      const text = !h ? '' : hit && well ? msg(node, 'well', vals) : h.match === 'exact' ? msg(node, 'exact', vals) : h.match === 'near' ? msg(node, 'near', vals) : h.match === 'miss' ? msg(node, 'miss', vals) : msg(node, 'error');
      const was = box.hidden;
      if (box.textContent !== text) box.textContent = text;
      box.hidden = !text;
      box.classList.toggle('is-warn', !!h && (well || h.match !== 'exact'));
      if (text && was) appear(box);
    }
    async function zipFind(btn) {
      const node = cur(), f = node && node.querySelector('[data-cqss-g-field="zip"]');
      if (!f || G.zipState === 'busy') return;
      if (G.zipState === 'use' || G.zipState === 'near') { useZipHit(); return; }
      if (G.zipState === 'estimate') { estimateAndGo(); return; }
      const zip = String(f.value || '').trim();
      if (!/^\d{5}$/.test(zip)) { fieldError(f, msg(node, 'bad')); invalid(f, '', btn); return; }
      fieldError(f, '');
      G.zip = zip;
      zipPaint(node, true);
      const h = await lookupZip(zip);
      if (cur() !== node) return;               // the visitor moved on while the map loaded
      G.zipHit = h.match === 'bad' ? null : h;
      zipPaint(node);
    }
    // the two ways to answer the hardness question swap in place, with no slide, and put the caret in the new field
    function via(id) {
      if (G.step === id) return;
      G.hardVia = id === 'zip' ? 'zip' : 'number';
      go(id, {instant: true, focus: false, scroll: false});
      const f = cur() && cur().querySelector(id === 'zip' ? '[data-cqss-g-field="zip"]' : '[data-cqss-g-field="hardness"]');
      if (f) try { f.focus({preventScroll: true}); } catch (_) { f.focus(); }
    }
    function useZipHit() {
      const h = G.zipHit;
      if (!h || h.gpg == null) return;
      applyZip(h, state.source === 'well');
      G.hardVia = 'zip'; mark('zip');
      track('cq_quiz_answer', {screen: 'zip', value: 'zip'});
      changed('zip');
      next();
    }
    function estimateAndGo() {
      const from = G.step;
      useEstimate();
      G.hardVia = 'number'; mark('hardness');
      track('cq_quiz_answer', {screen: from, value: 'estimate'});
      changed('estimate');
      next();
    }

    /* ---- the desktop pane while guided (G4 5.4): the visitor's answers, a finding from their own numbers, and why
       the current question is asked. Never a size, days, salt, product or price. Hidden on phones by the CSS. */
    const hardDone = () => (G.gpgGiven ? hardOk(rawHard()) : isAnswered('hardness') || state.useEstimate) && !needsCheck();
    function hardVals() {
      const raw = rawHard(), u = form.elements.unit.value, g = hardOk(raw) ? S.toGpg(Number(raw), u) : null;
      return {v: trimNum(Number(raw)), unit: UNIT_WORD[u] || u, g: g == null ? '' : fmt1(g), gpg: g, band: g == null ? '' : S.band(Math.min(g, 150)).label.toLowerCase(),
        bandKey: g == null ? '' : S.band(Math.min(g, 150)).key};
    }
    function hardVal() {
      if (state.useEstimate) return pmsg('val-hard-est');
      const h = hardVals();
      if (h.gpg == null) return '';
      if (state.hardSource === 'zip') return pmsg(state.source === 'well' ? 'val-hard-zipwell' : 'val-hard-zip', h);
      if (kept() && state.unit === 'gpg') return pmsg('val-hard-kept', h);
      return state.unit !== 'gpg' ? pmsg('val-hard-conv', h) : pmsg('val-hard-gpg', h);
    }
    function findCap() {
      if (state.useEstimate) return pmsg('find-est');
      const h = hardVals();
      if (h.gpg == null) return '';
      if (h.gpg > 150) return pmsg('find-beyond');
      if (state.hardSource === 'zip') return pmsg(state.source === 'well' ? 'find-zipwell' : 'find-zip', h);
      if (kept() && state.unit === 'gpg') return pmsg('find-kept', h);
      return state.unit === 'mgl' ? pmsg('find-conv', h) : pmsg('find-gpg', h);
    }
    function paintWait(r) {
      if (!on() || !waitList) return;
      readForm();
      const p = path(), a = k => G.answered.has(k), rows = [];
      if (a('source')) rows.push(['source', pmsg('val-source-' + (state.source || 'unsure'))]);
      if (p.includes('signs') && a('signs')) rows.push(['signs', signLabels() || pmsg('val-signs-none')]);
      const hd = hardDone();
      if (hd) rows.push(['hardness', hardVal()]);
      if (a('people')) rows.push(['people', String(state.people)]);
      if (a('baths')) rows.push(['baths', (state.baths >= 6 ? '6 or more' : String(state.baths)) + (a('style') && state.baths >= 2 ? ', ' + styleWord() : '')]);
      if (a('extras')) rows.push(['extras', extraLabels() || pmsg('val-extras-none')]);
      const sig = rows.map(x => x.join('=')).join('|');
      if (sig !== G.rowsSig) {
        const prev = G.rowKeys;
        waitList.innerHTML = rows.map(([k, v]) => '<li><span class="cqss-wait-k">' + esc(pmsg('row-' + k)) + '</span><span class="cqss-wait-v">' + esc(v) + '</span></li>').join('');
        if (!calm() && G.booted) Array.from(waitList.children).forEach((li, i) => { if (!prev.has(rows[i][0])) li.classList.add('is-new'); });
        G.rowsSig = sig; G.rowKeys = new Set(rows.map(x => x[0]));
      }
      // the finding: after the hardness answer the scale lights the visitor's band; after the people answer it gives way
      // to gallons x gpg = grains, counting up from 0 (J127, seeded), and stays true if an earlier answer changes
      if (P.start) P.start.hidden = false;
      const cap = hd ? findCap() : '';
      if (waitCap) { waitCap.hidden = !cap; if (cap && waitCap.textContent !== cap) waitCap.textContent = cap; }
      const band = hd ? (state.useEstimate ? S.band(10).key : hardVals().bandKey) : '';
      scaleLis.forEach((li, i) => li.classList.toggle('is-lit', !!band && BANDS[i] === band));
      if (waitTiles) {
        if (a('people') && hd && r && r.ready) {
          const first = waitTiles.hidden, gal = $('[data-cqss-wroll="gallons"]', waitTiles), grn = $('[data-cqss-wroll="grains"]', waitTiles);
          if (first) [gal, grn].forEach(n => { if (n && !rolls.has(n)) rolls.set(n, {value: 0, raf: 0}); });
          waitTiles.hidden = false;
          roll(gal, r.demand.gallons); roll(grn, r.demand.grainsDay);
          const w = $('[data-cqss-wgpg]', waitTiles), wl = $('[data-cqss-wgpg-label]', waitTiles);
          if (w) w.textContent = fmt1(r.water.comp);
          if (wl) wl.textContent = r.water.comp !== r.water.gpg ? 'gpg to remove' : 'gpg';
          if (first && !calm()) waitTiles.animate([{opacity: 0}, {opacity: 1}], {duration: 320, easing: 'ease'});
        } else waitTiles.hidden = true;
      }
      const node = cur(), why = node && node.querySelector('[data-cqss-why]');
      if (waitWhy) setText(waitWhy, why ? why.textContent.replace(/\s+/g, ' ').trim() : '', !G.booted);
    }

    /* ---- the sizing moment (G4 5.5, 8, 9.2): only numbers the engine just produced; 1.75 s; skippable; ends on any key
       press or tap inside the calculator band; plays once per run and never with reduced motion or Save-Data */
    function sizingLines(r) {
      const h = hardVals(), n = r.demand.people;
      const l1 = h.gpg != null && h.gpg > 150 ? pmsg('size-hard-beyond') : state.useEstimate ? pmsg('size-hard-est')
        : state.hardSource === 'zip' ? pmsg(state.source === 'well' ? 'size-hard-zipwell' : 'size-hard-zip', h) : kept() && state.unit === 'gpg' ? pmsg('size-hard-kept', h)
          : state.unit !== 'gpg' ? pmsg('size-hard-conv', h) : pmsg('size-hard-gpg', h);
      const l2 = pmsg('size-people', {people: n === 1 ? '1 person' : n + ' people', grains: fmt(r.demand.grainsDay)});
      const part = k => (r.water.parts || []).find(x => x.key === k && x.gpg > 0);
      const l3 = r.ahead.includes('metal') ? pmsg('size-metal') : r.ahead.includes('tannin') ? pmsg('size-tannin')
        : part('neutralizer') ? pmsg('size-neutralizer', {n: fmt1(part('neutralizer').gpg)})
          : part('metals') ? pmsg('size-iron', {n: fmt1(part('metals').gpg)}) : pmsg('size-peak', {peak: fmt1(r.flow.peak)});
      return [l1, l2, l3];
    }
    function sizing(r) {
      if (!sizingEl || !r || !r.ready) { revealResult(); return; }
      const lines = sizingLines(r);
      $$('[data-cqss-sizing-line]', sizingEl).forEach((li, i) => { li.textContent = lines[i] || ''; li.classList.remove('is-on'); });
      sizingEl.classList.remove('is-run');
      sizingEl.animate([{opacity: 0}, {opacity: 1}], {duration: 240, easing: 'ease'});
      requestAnimationFrame(() => { if (G.sizing) sizingEl.classList.add('is-run'); });
      track('cq_quiz_matching_view', {mode: 'guided'});
      G.played = true;
      const timers = [350, 850, 1350].map((t, i) => later(() => { const li = $('[data-cqss-sizing-line="' + (i + 1) + '"]', sizingEl); if (li) li.classList.add('is-on'); }, t));
      timers.push(later(() => endSizing(false), 1750));
      const stop = e => { if (e.type === 'keydown' && (e.repeat || /^(Shift|Control|Alt|Meta|CapsLock)$/.test(e.key))) return; endSizing(true); };
      const band = calcBand || root;
      band.addEventListener('pointerdown', stop, true); band.addEventListener('keydown', stop, true);
      G.sizing = {timers, off: () => { band.removeEventListener('pointerdown', stop, true); band.removeEventListener('keydown', stop, true); }};
    }
    function endSizing(skipped) {
      const s = G.sizing;
      if (!s) return;
      G.sizing = null; s.timers.forEach(clearTimeout); s.off();
      if (skipped) track('cq_quiz_matching_skip', {mode: 'guided'});
      if (sizingEl) sizingEl.classList.remove('is-run');
      revealResult();
    }
    // the reveal (G4 9.3): kicker, size, the line word by word, then the lower parts in turn; all at once when calm.
    // The size rows, why line and drawer cases of 5.6 to 5.8 arrive with stage 3; their elements animate when present.
    function revealResult() {
      root.removeAttribute('data-cqss-phase');
      const c = result && result.ready ? chosen(result) : null;
      if (c) { track('cq_quiz_result_view', resultPayload(c, 'guided')); lastReported = reportKey(c); }
      if (calm()) return;
      const shown = n => n && !n.hidden && n.getClientRects().length > 0;
      const rise = (n, delay, dist, dur) => { if (shown(n)) n.animate([{opacity: 0, transform: 'translateY(' + dist + 'px)'}, {opacity: 1, transform: 'none'}], {duration: dur, delay, easing: GLIDE, fill: 'backwards'}); };
      rise(P.eqBox, 0, 10, 420);
      rise($('.cqss-pane > .cqss-kicker'), 0, 8, 320);
      rise(P.links, 60, 8, 320);
      rise(P.size, 60, 12, 420);                               // a size is not a count: no roll
      if (shown(P.sub)) words(P.sub, 1);
      rise(P.stats, 160, 8, 320);
      rise($('[data-cqss-why-line]'), 240, 8, 320);
      const rowsEl = $('[data-cqss-rows]');
      if (shown(rowsEl)) { rise(rowsEl, 300, 8, 320); rowsEl.classList.add('is-in'); }
      const wk = $('[data-cqss-workings]');
      if (shown(wk)) wk.animate([{opacity: 0}, {opacity: 1}], {duration: 240, delay: 420, easing: 'ease', fill: 'backwards'});
      rise(matchEl, 480, 12, 320);
    }

    /* ---- ending the run */
    // the card's last frame, frozen over the form while the form rises in under it (desktop and phones)
    function cardGhost() {
      if (!el || !el.getClientRects().length) return null;
      const g = el.cloneNode(true);
      $$('template, [data-cqss-copy]', g).forEach(n => n.remove());
      [g].concat($$('[id]', g)).forEach(n => n.removeAttribute('id'));
      g.removeAttribute('data-cqss-guide'); g.removeAttribute('aria-labelledby');
      g.classList.add('cqss-card-ghost'); g.setAttribute('aria-hidden', 'true'); g.setAttribute('inert', ''); g.inert = true;
      const fr = form.getBoundingClientRect(), r = el.getBoundingClientRect();
      g.style.left = (r.left - fr.left) + 'px'; g.style.top = (r.top - fr.top) + 'px'; g.style.width = r.width + 'px'; g.style.height = r.height + 'px';
      form.appendChild(g);
      return g;
    }
    function fold(folded) {
      if (folded) root.setAttribute('data-cqss-folded', '1'); else root.removeAttribute('data-cqss-folded');
      if (changeBtn) { changeBtn.setAttribute('aria-expanded', String(!folded)); setCase(changeBtn, folded ? 'closed' : 'open'); }
      if (formBody) formBody.classList.remove('is-in');
    }
    function leave() {
      clearTimeout(G.pending); finishWords();
      G.ended = true;
      root.removeAttribute('data-cqss-mode'); root.removeAttribute('data-cqss-step');
      if (stage) stage.textContent = '';
      store({v: 1, done: true});
      if (moreHasValues()) accordion.open(more, true);        // Fine-tune opens at once when it holds a value
      requestAnimationFrame(() => placeAll(form));            // the thumbs measured a hidden form (G2 risk 5)
    }
    // See my size (G4 9.1): answers are already in the form; the result is computed, focus lands on its sentence, the
    // card gives way to the form (desktop) or the answers card (phones), and the moment plays in the pane
    function showResult(via) {
      if (!on()) return;
      prune();
      const desktop = window.innerWidth > 820, moment = via === 'guided' && !calm() && !G.played;
      const top0 = el.getBoundingClientRect().top, card = calm() ? null : cardGhost();
      leave();
      G.shown = true;
      root.setAttribute('data-cqss-ran', '1');
      fold(!desktop);
      if (moment) root.setAttribute('data-cqss-phase', 'sizing');
      render();
      lastSaid = announceText();                              // the heading carries it; the polite region stays quiet
      focusEl(resultH);
      followChart();
      writeUrlNow();
      if (card) { void window.getComputedStyle(card).opacity; card.classList.add('is-out'); later(() => card.remove(), swapMs() + 60); }
      if (!calm()) [recapEl].concat(desktop && formBody ? Array.from(formBody.children) : []).forEach((n, i) => {
        if (n) n.animate([{opacity: 0, transform: 'translateY(8px)'}, {opacity: 1, transform: 'none'}], {duration: 320, delay: Math.min(i, 3) * 40, easing: GLIDE, fill: 'backwards'});
      });
      // same-frame scroll correction (no reliance on scroll anchoring), then the pane into view on phones
      if (desktop) {
        window.scrollTo({top: 0, behavior: 'auto'});   // the result opens where the questions did, under the site header
      } else if (resultEl) {
        // phones show the recommendation first (the answers card sits under it): bring its top to just under the header
        window.scrollTo({top: Math.max(0, resultEl.getBoundingClientRect().top + window.scrollY - 88), behavior: 'auto'});
      }
      if (moment) sizing(result); else revealResult();
    }
    // Skip, or the page below used mid-run (chart cell, priority, size card): the run ends without the moment
    function finish(via) {
      if (!on()) return;
      track('cq_quiz_skip', {from: G.step, via});
      const hadHard = !!form.elements.hardness.value || state.useEstimate;
      const top0 = el.getBoundingClientRect().top;
      leave();
      fold(false);
      const c = render();
      if (via !== 'skip') return;                             // the chart, priority or card action follows and does the rest
      followChart();
      writeUrlNow();
      if (result && result.ready) { G.shown = true; reportSoon(c); }
      const top1 = form.getBoundingClientRect().top;
      if (Math.abs(top1 - top0) > 1) jump(top1 - top0);
      if (form.getBoundingClientRect().top < 88) jump(form.getBoundingClientRect().top - 88);
      sayNow(pmsg('say-skip'));
      focusEl(hadHard ? resultH : form.elements.hardness);     // a direct tap, so the keyboard may open
    }
    // Start over (G4 10): every control back to its v2.1 default, URL and storage cleared, the first question again
    function restart() {
      if (!allowed || !el || !stage) return;
      track('cq_quiz_retake', {});
      if (G.sizing) { G.sizing.timers.forEach(clearTimeout); G.sizing.off(); G.sizing = null; }
      clearTimeout(G.pending); clearTimeout(reportTimer); finishWords();
      form.elements.hardness.value = ''; form.elements.unit.value = 'gpg'; form.elements.people.value = 4;
      numberFields.forEach(k => { if (form.elements[k]) form.elements[k].value = ''; });
      if (form.elements.zip) form.elements.zip.value = '';
      Object.assign(state, {hardSource: null, useEstimate: false, source: null, baths: 2, bathStyle: 'combo', hose: false, extraHeads: 0, wfh: false,
        signs: [], usePreset: 'typical', regenerant: 'salt', septic: false, preference: 'balanced', choice: null, setup: null});
      keptGpg = null; keptMgl = null;
      reflect(); hideFound();
      if (zipWrap) { zipWrap.hidden = true; const zb = $('[data-cqss-do="zip"]'); if (zb) zb.setAttribute('aria-expanded', 'false'); }
      accordion.close(more, true);
      Object.assign(G, fresh());
      $$('.cqss-card.is-pick', cardsEl).forEach(c => c.classList.remove('is-pick'));
      lastReported = '';
      root.removeAttribute('data-cqss-ran'); root.removeAttribute('data-cqss-phase');
      fold(false);
      try { sessionStorage.removeItem(KEY); } catch (_) { /* private mode */ }
      root.setAttribute('data-cqss-mode', 'guided');
      stage.textContent = '';
      render();
      writeUrlNow(true);
      go('source', {dir: -1});
      root.setAttribute('data-cqss-gate', 'start');
      window.scrollTo({top: 0, behavior: 'auto'});
      focusEl($('.cqss-land [data-cqss-do="start"]'));
      say(pmsg('say-restart'));
    }
    // phones: "Change answers" opens the form under the answers card (G4 5.10, 9.4)
    function change() {
      const opening = root.hasAttribute('data-cqss-folded');
      fold(!opening);
      if (!opening) return;
      if (formBody && !calm()) { void formBody.offsetWidth; formBody.classList.add('is-in'); later(() => formBody.classList.remove('is-in'), 420); }
      requestAnimationFrame(() => placeAll(form));
      const lg = $('#cqss-legend-water');
      if (lg) { lg.setAttribute('tabindex', '-1'); focusEl(lg); }
    }
    // the answers card's one-line summary (phones), e.g. City water · 15 gpg · 4 people · 2 bathrooms, tubs with showers
    function recap() {
      // the header over the calculator: after the questions it reads Your answers / Start over; from the full calculator
      // link it reads Full calculator / Answer the questions instead, the way back to the guided start (AJ 08:38)
      const ran = root.hasAttribute('data-cqss-ran');
      const k = $('[data-cqss-recap-kicker]'), rb = $('[data-cqss-restart-label]');
      if (k) k.textContent = ran ? 'Your answers' : 'Full calculator';
      if (rb) rb.textContent = ran ? 'Start over' : 'Answer the questions instead';
      if (!recapLineEl || !ran) return;
      const parts = [];
      if (state.source === 'city' || state.source === 'well') parts.push(pmsg('val-source-' + state.source));
      const hv = hardVal(); if (hv) parts.push(hv);
      parts.push(state.people === 1 ? '1 person' : state.people + ' people');
      parts.push(state.baths === 1 ? '1 bathroom' : (state.baths >= 6 ? '6 or more' : state.baths) + ' bathrooms, ' + styleWord());
      const x = extraLabels(); if (x) parts.push(x);
      const t = parts.join(' · ');
      if (recapLineEl.textContent !== t) recapLineEl.textContent = t;
    }
    // the first edit of each field after a result (G4 9.4)
    function touch(why) {
      if (!G.shown || on() || !why || /^(url|skip)$/.test(why)) return;
      const f = why.indexOf(':') > -1 ? why.split(':')[1] : why;
      if (!f || G.touched.has(f)) return;
      G.touched.add(f);
      track('cq_quiz_change_answer', {field: f});
    }
    const checkState = () => kept() ? 'kept' : G.checked === 'mgl' || G.checked === 'gpg' ? G.checked : 'none';

    /* ---- the hero button (G4 5.1): the card to 88 px under the top, focus on the question (or the 01 legend), never an input */
    function hero() {
      if (!started) { started = true; track('cq_quiz_start', {screen: on() ? G.step : 'calc', via: 'hero'}); }
      const target = on() ? el : root.hasAttribute('data-cqss-folded') && recapEl ? recapEl : form;
      window.scrollTo({top: target.getBoundingClientRect().top + window.scrollY - 88, behavior: calm() ? 'auto' : 'smooth'});
      if (on()) { const n = cur(); focusEl(n && n.querySelector('.cqv-q-title')); return; }
      const lg = $('#cqss-legend-water');
      if (lg && lg.getClientRects().length) { lg.setAttribute('tabindex', '-1'); focusEl(lg); } else focusEl(resultH);
    }
    // the start page (AJ 2026-10-15 06:44): Start opens the questions, the quiet link opens the full calculator
    const gated = () => root.getAttribute('data-cqss-gate') === 'start';
    function openGate(full) {
      root.removeAttribute('data-cqss-gate');
      if (full && on()) finish('skip');
      window.scrollTo({top: 0, behavior: 'auto'});   // one place every time: the questions start under the site header
      if (on()) {
        if (!started) { started = true; track('cq_quiz_start', {screen: G.step, via: 'hero'}); }
        const n = cur(); if (n && !calm()) $$(':scope > *', n).forEach((k, i) => k.animate([{opacity: 0, transform: 'translateY(8px)'}, {opacity: 1, transform: 'none'}], {duration: 320, delay: i * 40, easing: GLIDE, fill: 'backwards'}));
        focusEl(n && n.querySelector('.cqv-q-title'));
        requestAnimationFrame(() => placeAll(el));
      } else {
        requestAnimationFrame(() => placeAll(form));
        const lg = $('#cqss-legend-water');
        if (lg && lg.getClientRects().length) { lg.setAttribute('tabindex', '-1'); focusEl(lg); } else focusEl(resultH);
      }
    }
    function act(what, b, e) {
      if (what === 'start' || what === 'full') {
        if (e) e.preventDefault();
        // back on the start page after a result (the quiz header's Back keeps the answers): Size my softener starts over
        if (what === 'start' && gated() && !on() && allowed && el && stage) restart();
        if (gated() || what === 'full') openGate(what === 'full'); else hero();
        return;
      }
      if (b && b.closest('.cqq-ghost, .cqss-card-ghost')) return;
      switch (what) {
        case 'g-back': back(); break;
        case 'g-skip': finish('skip'); break;
        case 'g-next': cont(b); break;
        case 'g-see': see(); break;
        case 'g-test': toggleTest(); break;
        case 'g-zip': case 'g-number': via(what === 'g-zip' ? 'zip' : 'hardness'); break;
        case 'g-zip-find': zipFind(b); break;
        case 'g-estimate': estimateAndGo(); break;
        case 'g-minus': stepPeople(-1); break;
        case 'g-plus': stepPeople(1); break;
        case 'g-restart': restart(); break;
        case 'g-change': change(); break;
        case 'g-skip-sizing': endSizing(true); break;
        default: break;
      }
    }

    /* ---- events inside the card */
    if (stage) {
      stage.addEventListener('click', e => {
        const b = e.target.closest('button[data-cqss-pick]');
        if (!b || b.closest('.cqq-ghost')) return;
        const v = b.dataset.cqssPick, i = v.indexOf(':');
        pick(v.slice(0, i), v.slice(i + 1));
        if (v.indexOf('check:') === 0) b.setAttribute('aria-pressed', 'true');
      });
      stage.addEventListener('change', e => {
        const t = e.target;
        if (t.closest('.cqq-ghost')) return;
        if (t.matches('input[type="checkbox"][data-cqss-pick]')) { const v = t.dataset.cqssPick, i = v.indexOf(':'); pick(v.slice(0, i), v.slice(i + 1), t); }
        else if (t.matches('select[data-cqss-g-field="unit-other"]')) {
          setField('unit', t.value, true); G.checked = null;
          const n = cur(); if (n) { paintUnits(n, false); hardLive(n); primaryCase(n, 'hardness'); }
          changed('unit');
        }
      });
      stage.addEventListener('input', e => {
        const f = e.target.closest && e.target.closest('input[data-cqss-g-field]');
        if (!f || f.closest('.cqq-ghost')) return;
        const k = f.dataset.cqssGField, node = cur(), invalidNow = f.getAttribute('aria-invalid') === 'true';
        if (k === 'hardness') {
          setField('hardness', f.value, true); G.checked = null;
          if (invalidNow && hardOk(normNum(f.value))) fieldError(f, '');      // errors clear while typing, never appear
          if (node) { hardLive(node); primaryCase(node, 'hardness'); }
          changed('input:hardness');
        } else if (k === 'zip') {
          G.zip = String(f.value || '').trim();
          if (G.zipHit) { G.zipHit = null; if (node) zipPaint(node); }
          if (invalidNow) fieldError(f, '');
        } else if (TEST.includes(k)) {
          setField(k, f.value, true);
          if (invalidNow && !testReason(k, f.value)) fieldError(f, '');
          changed('input:' + k);
        } else if (k === 'people') {
          const n = parseInt(normNum(f.value), 10);
          if (n >= 1) setField('people', Math.min(40, n), true);
          if (invalidNow && n >= 6 && n <= 40) fieldError(f, '');
          changed('people');
        }
      });
      // an error shows after Continue or when the field is left, never while typing. While a pointer is down the blur
      // error waits for the release: shown at mousedown, the line would push Continue down under the pointer and the
      // click would be lost (the click checks the field itself)
      let pressing = false, blurred = null;
      const blurError = f => {
        if (!f || !f.isConnected || f.closest('.cqq-ghost') || !on() || document.activeElement === f) return;
        const k = f.dataset.cqssGField, raw = normNum(f.value), node = cur();
        if (raw === '' || !node || !node.contains(f)) return;
        if (k === 'hardness' && !hardOk(raw)) fieldError(f, msg(node, hardReason(raw)));
        else if (TEST.includes(k)) { const r = testReason(k, raw); if (r) fieldError(f, msg(node, r)); }
      };
      (el || stage).addEventListener('pointerdown', () => { pressing = true; }, true);
      const release = () => { if (!pressing) return; later(() => { pressing = false; const f = blurred; blurred = null; blurError(f); }, 0); };
      window.addEventListener('pointerup', release, true);
      window.addEventListener('pointercancel', release, true);
      stage.addEventListener('focusout', e => {
        const f = e.target.closest && e.target.closest('input[data-cqss-g-field]');
        if (!f || f.closest('.cqq-ghost') || !on()) return;
        if (pressing) blurred = f; else blurError(f);
      });
    }
    // keyboard (G4 15, family js:2836 to 2845): arrows, Home and End move within a group; Enter in a field presses the
    // screen's primary; Enter on a checkbox row ticks it
    if (el) el.addEventListener('keydown', e => {
      const t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('input[data-cqss-g-field]') && e.key === 'Enter') {
        e.preventDefault();
        const node = cur(), btn = node && (t.closest('[data-cqss-g-more]') ? node.querySelector('[data-cqss-g-more] [data-cqss-do="g-next"]')
          : node.querySelector('[data-cqss-do="g-next"], [data-cqss-do="g-zip-find"], [data-cqss-do="g-see"]'));
        if (btn) btn.click();
        return;
      }
      const group = t.closest('.cqv-q-options, .cqv-q-units');
      if (group && ['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(e.key)) {
        const items = $$('button.cqv-q-option, .cqv-q-option input, .cqv-q-units button', group), i = items.indexOf(t);
        if (i < 0) return;
        e.preventDefault();
        const j = e.key === 'Home' ? 0 : e.key === 'End' ? items.length - 1 : /Down|Right/.test(e.key) ? Math.min(items.length - 1, i + 1) : Math.max(0, i - 1);
        items[j].focus();
        return;
      }
      if (group && e.key === 'Enter' && t.matches('input[type="checkbox"]')) { e.preventDefault(); t.click(); }
    });

    /* ---- boot (G4 11.1, 14 item 5): choose the entry, hydrate the pre-painted screen, or start the calculator */
    function hydrate(step) {
      const pre = cur();
      if (pre && pre.dataset.cqssScreen === step) {
        // the pre-paint script's clone: keep anything typed into it before this file ran, then paint it from state
        $$('input[data-cqss-g-field]', pre).forEach(f => {
          const k = f.dataset.cqssGField;
          if (!f.value) return;
          if (k === 'zip') G.zip = f.value.trim();
          else if (k === 'hardness' || TEST.includes(k)) setField(k, f.value, true);
        });
        paintInto(pre, step);
      } else {
        stage.textContent = '';
        const node = paint(step);
        if (node) stage.appendChild(node);
      }
      G.step = step;
      root.setAttribute('data-cqss-mode', 'guided');
      root.setAttribute('data-cqss-step', step);
    }
    // the first screen_view waits until the card is at least half on screen (G4 16)
    function watchFirst() {
      const send = () => { if (G.seen || !on()) return; G.seen = true; track('cq_quiz_screen_view', {screen: G.step, chapter: chOf(G.step), mode: 'guided'}); };
      if (!('IntersectionObserver' in window)) { send(); return; }
      const io = new IntersectionObserver(es => { if (es.some(x => x.isIntersecting && x.intersectionRatio >= 0.5)) { io.disconnect(); send(); } }, {threshold: [0, 0.5, 1]});
      io.observe(el);
    }
    // a tap made before this file ran, recorded by the pre-paint script, applied as if made now
    function applyEarly() {
      const v = root.getAttribute('data-cqss-early');
      root.removeAttribute('data-cqss-early');
      if (!v || !on()) return;
      const i = v.indexOf(':'), kind = v.slice(0, i), what = v.slice(i + 1), node = cur();
      if (kind === 'pick') {
        const t = node && node.querySelector('[data-cqss-pick="' + what + '"]');
        if (!t) return;
        const j = what.indexOf(':');
        if (t.matches('input[type="checkbox"]')) { t.checked = !t.checked; pick(what.slice(0, j), what.slice(j + 1), t); }
        else { pick(what.slice(0, j), what.slice(j + 1)); if (what.indexOf('check:') === 0) t.setAttribute('aria-pressed', 'true'); }
      } else if (kind === 'do' && what !== 'g-back') act(what, el.querySelector('[data-cqss-do="' + what + '"]'));
    }
    function boot() {
      const q = new URLSearchParams(location.search);
      const stored = allowed ? load() : null;
      const entry = !allowed || !el || !stage || !tpl || !paneCopy ? 'calc'
        : root.hasAttribute('data-cqss-fallback') ? 'fallback'
          : RESULT_KEYS.some(k => q.has(k)) ? 'url'
            : stored && stored.done ? 'done'
              : q.has('gpg') ? 'gpg'
                : stored && stored.step ? 'resume'
                  : /^#cqss-(sizes|chart|how|water|big|faq)$/.test(location.hash) ? 'hash' : 'guided';
      const fromUrl = readUrl();
      const guided = ['guided', 'resume', 'gpg', 'hash'].includes(entry);
      if (guided) {
        let step = 'source';
        if (entry === 'resume') {
          try { decodeState(new URLSearchParams(stored.q || '')); } catch (_) { /* a bad string: start from the top */ }
          (stored.answered || []).forEach(id => { if (ORDER.includes(id)) G.answered.add(id); });
          G.hardVia = stored.via === 'zip' ? 'zip' : 'number';
          if (G.hardVia === 'zip' && form.elements.hardness.value && !state.useEstimate) state.hardSource = 'zip';
          if (G.answered.has('people')) G.peoplePick = state.people >= 6 ? '6plus' : String(state.people);
          step = stored.step === 'check' ? 'hardness' : ORDER.includes(stored.step) ? stored.step : 'source';
        }
        G.gpgGiven = entry === 'gpg' && hardOk(rawHard());
        root.setAttribute('data-cqss-mode', 'guided');
        hydrate(firstGap(step));
        render();
        paintProgress(1);
        sync();
        watchFirst();
        window.addEventListener('pagehide', () => { if (on() && !G.exitSent) { G.exitSent = true; track('cq_quiz_exit', {last: G.step}); } });
      } else {
        root.removeAttribute('data-cqss-mode'); root.removeAttribute('data-cqss-step');
        if (stage) stage.textContent = '';
        if (entry === 'url' && allowed && el) { root.setAttribute('data-cqss-ran', '1'); G.shown = true; G.ended = true; fold(window.innerWidth <= 820); }
        render();
      }
      $$('.cqss-seg').forEach(mountThumb);
      reveal();
      track('cq_quiz_landing_view', {entry});
      if (!guided && fromUrl.any && result.ready) { lastReported = ''; changed('url'); } else if (!guided) followChart();
      // reduced motion turned on mid-run: a running reveal ends at once and a moment in progress is skipped
      const onCalm = () => {
        if (!calm()) return;
        finishWords(); endSizing(false);
        try { root.getAnimations({subtree: true}).forEach(a => { try { a.finish(); } catch (_) { /* endless */ } }); } catch (_) { /* old browsers */ }
      };
      if (mqCalm) { if (mqCalm.addEventListener) mqCalm.addEventListener('change', onCalm); else if (mqCalm.addListener) mqCalm.addListener(onCalm); }
      G.booted = true;
      root.setAttribute('data-cqss-live', '1');               // last: the page script is in charge
      if (guided) applyEarly();
    }

    /* Full screen like the family quizzes (AJ 2026-10-15 12:37). Past the start page the site header and breadcrumbs hide
       and the quiz header sticks to the top (html.cqss-fs-scroll); while the questions run the footer and related
       articles hide too (html.cqss-fs), so the question screen is the whole screen. Kept in step with the root's gate
       and mode, whatever changes them; the fallback and the guided setting turned off leave the page as it was. */
    const htmlEl = document.documentElement;
    const syncChrome = () => {
      const past = allowed && !root.hasAttribute('data-cqss-gate') && !root.hasAttribute('data-cqss-fallback');
      const guided = root.getAttribute('data-cqss-mode') === 'guided';
      htmlEl.classList.toggle('cqss-fs', past && guided);
      htmlEl.classList.toggle('cqss-fs-scroll', past && !guided);
      if (qBack) qBack.setAttribute('aria-label', guided && backBtn && !backBtn.hidden ? 'Back to the previous question' : 'Back to the start page');
    };
    // the quiz header's Back: the previous question; from the first one, or from the result or the full calculator, the
    // start page with the answers kept (Size my softener there starts a fresh run; Start over stays in the result)
    const qBack = $('[data-cqss-qhead] .cqv-quiz-back');
    if (qBack) qBack.setAttribute('role', 'button');
    new MutationObserver(syncChrome).observe(root, {attributes: true, attributeFilter: ['data-cqss-gate', 'data-cqss-mode', 'data-cqss-fallback', 'data-cqss-step']});
    syncChrome();
    if (qBack) qBack.addEventListener('click', e => {
      if (!allowed || !root.hasAttribute('data-cqss-live')) return;
      e.preventDefault();
      if (on() && backBtn && !backBtn.hidden) { back(); return; }
      if (on() && !G.answered.size) { try { sessionStorage.removeItem(KEY); } catch (_) { /* private mode */ } }
      root.setAttribute('data-cqss-gate', 'start');
      syncChrome();                                    // the site header is back before the scroll, so it lands at the top
      window.scrollTo({top: 0, behavior: 'auto'});
      focusEl($('.cqss-land [data-cqss-do="start"]'));
    });

    return {on, step: () => G.step, act, boot, sync, save, paintWait, recap, finish, touch, checkState, markShown: () => { G.shown = true; }};
  })();

  /* ------------------------------------------------------------------ sizing chart: tabs, fill, follow the household */
  const tabFor = (baths, style) => style === 'shower' ? 'a' : style === 'mixed' ? (baths >= 6 ? 'b' : 'a') : baths >= 5 ? 'c' : baths === 4 ? 'b' : 'a';
  const KEYS = {a: ['15', '20', 'com3', 'com4'], b: ['20', 'com3', 'com4'], c: ['com3', 'com4']};
  const COLS = [5, 10, 15, 20, 25, 30];
  let phoneCol = 2;
  function showTab(id, animate) {
    if (!tabs) return;
    $$('[role="tab"]', tabs).forEach(b => { const on = b.dataset.tab === id; b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1; });
    $$('.cqss-tabpanel').forEach(p => {
      const on = p.dataset.panel === id;
      p.hidden = !on;
      p.classList.remove('is-in');
      if (on && animate && !calm()) { $$('td', p).forEach((td, i) => td.style.setProperty('--d', (i % 6) + Math.floor(i / 6))); void p.offsetWidth; p.classList.add('is-in'); }
    });
    $$('[data-cqss-key] [data-k]').forEach(k => { k.hidden = !KEYS[id].includes(k.dataset.k); });
    markYou();
  }
  function markYou() {
    $$('td.is-you').forEach(td => td.classList.remove('is-you'));
    if (!result || !result.ready) return;
    const p = result.demand.people, h = result.water.gpg;
    const col = COLS.indexOf(h);
    if (p > 8 || col < 0) return;
    const panel = $('.cqss-tabpanel:not([hidden])');
    const row = panel && $$('tbody tr', panel)[p - 1];
    const td = row && row.children[col + 1];
    if (td) td.classList.add('is-you');
  }
  function followChart() {
    if (!tabs || !result || !result.ready) { markYou(); return; }
    const want = tabFor(state.baths, state.bathStyle);
    const now = $('[aria-selected="true"]', tabs);
    if (!now || now.dataset.tab !== want) showTab(want, true); else markYou();
    if (colpick) { const near = COLS.reduce((a, v, i) => Math.abs(v - result.water.gpg) < Math.abs(COLS[a] - result.water.gpg) ? i : a, 0); setCol(near); }
  }
  if (tabs) {
    tabs.addEventListener('click', e => { const b = e.target.closest('[role="tab"]'); if (b) { showTab(b.dataset.tab, true); track('cq_quiz_chart_tab', {tab: b.dataset.tab}); } });
    tabs.addEventListener('keydown', e => {
      const list = $$('[role="tab"]', tabs), i = list.findIndex(b => b.getAttribute('aria-selected') === 'true');
      const n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? list.length - 1 : null;
      if (n == null) return;
      e.preventDefault();
      const b = list[(n + list.length) % list.length]; b.focus(); showTab(b.dataset.tab, true);
    });
  }
  // phones: one hardness column at a time
  let colpick = null;
  const phoneMq = window.matchMedia ? window.matchMedia('(max-width: 600px)') : null;
  function setCol(i) {
    phoneCol = i;
    if (colpick) setPressed(colpick, String(COLS[i]));
    $$('.cqss-tabpanel').forEach(p => {
      if (!phoneMq || !phoneMq.matches) { p.removeAttribute('data-col'); return; }
      p.setAttribute('data-col', String(COLS[i]));
      $$('tr', p).forEach(tr => { Array.from(tr.children).forEach((cell, ci) => cell.classList.toggle('is-col', ci === i + 1)); });
    });
  }
  if (tabs) {
    colpick = document.createElement('div');
    colpick.className = 'cqss-seg cqss-colpick';
    colpick.setAttribute('role', 'group');
    colpick.setAttribute('aria-label', 'Hardness in grains per gallon');
    colpick.innerHTML = COLS.map(v => '<button type="button" aria-pressed="false" value="' + v + '">' + v + '</button>').join('');
    tabs.insertAdjacentElement('afterend', colpick);
    colpick.addEventListener('click', e => { const b = e.target.closest('button'); if (b) setCol(COLS.indexOf(+b.value)); });
    setCol(phoneCol);
    if (phoneMq) { const on = () => setCol(phoneCol); if (phoneMq.addEventListener) phoneMq.addEventListener('change', on); else if (phoneMq.addListener) phoneMq.addListener(on); }
  }
  root.addEventListener('click', e => {
    const cell = e.target.closest('[data-cqss-fill]');
    if (!cell) return;
    if (guide.on()) guide.finish('chart');      // a chart cell mid-run ends the run (G4 10), then fills the form as today
    if (root.getAttribute('data-cqss-gate') === 'start') root.removeAttribute('data-cqss-gate');   // from the start page too
    const [h, p, b] = cell.dataset.cqssFill.split('|');
    form.elements.unit.value = 'gpg';
    form.elements.hardness.value = h;
    form.elements.people.value = p;
    hideFound();
    state.hardSource = 'measured'; state.useEstimate = false; state.choice = null; state.setup = null;
    state.baths = parseInt(b, 10); state.bathStyle = 'combo'; state.preference = 'balanced';
    $$('[data-cqss-seg]').forEach(g => setPressed(g, state[g.dataset.cqssSeg]));
    setPressed(pref, 'balanced');
    changed('chart');
    track('cq_quiz_chart_fill', {gpg: +h, people: +p, baths: +b});
    scrollToResult();
  });

  /* ------------------------------------------------------------------ cart */
  root.addEventListener('click', async e => {
    const b = e.target.closest('[data-cqss-add]');
    if (!b) return;
    const msg = $('[data-cqss-cart-msg]');
    const c = chosen(result);
    if (!c.item) return;
    b.setAttribute('aria-busy', 'true'); b.disabled = true;
    const label = b.textContent; b.textContent = 'Adding...';
    const base = (root.dataset.root || '/').replace(/\/?$/, '/');
    try {
      const res = await fetch(base + 'cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items: [{id: c.item.variant.id, quantity: 1, properties: {_Quiz: 'Softener size calculator', '_Quiz match': c.size.key + (c.setupKey && c.setupKey !== 'softener' ? '+' + c.setupKey : '')}}]})});
      if (!res.ok) throw new Error('add failed');
      track('cq_quiz_add_to_cart', {outcome: c.size.key, setup: c.setupKey || 'softener', variant: String(c.item.variant.id)});
      try { fetch(base + 'cart/update.js', {method: 'POST', credentials: 'same-origin', keepalive: true, headers: {'Content-Type': 'application/json'}, body: JSON.stringify({attributes: {Quiz: 'Softener size calculator', 'Quiz match': c.size.key}})}); } catch (_) { /* best effort */ }
      const mini = document.querySelector('mini-cart');
      let opened = false;
      if (mini && typeof mini.updateSectionContents === 'function' && typeof mini.open === 'function') {
        try { await mini.updateSectionContents(); mini.open(b); opened = true; } catch (_) { opened = false; }
      }
      if (!opened) window.location.assign(root.dataset.cartUrl || '/cart');
    } catch (_) {
      track('cq_quiz_add_to_cart_error', {outcome: c.size.key});
      if (msg) { msg.textContent = 'We could not add this to your cart. Please try again, or call 1-800-934-0051.'; msg.hidden = false; }
    } finally {
      b.removeAttribute('aria-busy'); b.disabled = false; b.textContent = label;
    }
  });
  root.addEventListener('click', e => { if (e.target.closest('[data-cqss-configure]')) track('cq_quiz_configure_open', {outcome: result && result.pick}); });

  /* ------------------------------------------------------------------ share link (never the ZIP) */
  const PARAMS = {hardness: 'h', unit: 'u', people: 'p', baths: 'b', bathStyle: 'bs', source: 'src', iron: 'fe', manganese: 'mn', ph: 'ph', nitrate: 'no3', tds: 'tds', alkalinity: 'alk', usePreset: 'use', billGallons: 'bill', pumpGpm: 'pump', regenerant: 'reg', preference: 'pref', choice: 'size'};
  // the other result keys; the section's pre-paint script lists the same set (tools/test-softener-sizing.mjs compares them)
  const EXTRA_PARAMS = ['est', 'sg', 'x', 'kg', 'km'];
  const RESULT_KEYS = Object.values(PARAMS).concat(EXTRA_PARAMS);
  const DEFAULTS = {unit: 'gpg', people: 4, baths: 2, bathStyle: 'combo', usePreset: 'typical', regenerant: 'salt', preference: 'balanced'};
  /* One codec (G4 11.2 and 11.3, decision 23): the share URL and the tab's sessionStorage both carry this string, so
     there is no second answer format. Never the ZIP. kg=1 / km=1 keep a confirmed unit, so a reload or a shared link
     never asks the unit question again. */
  function encodeState() {
    readForm();
    const q = new URLSearchParams();
    Object.keys(PARAMS).forEach(k => {
      const v = state[k];
      if (v != null && v !== '' && String(v) !== String(DEFAULTS[k])) q.set(PARAMS[k], v);
    });
    if (state.useEstimate) q.set('est', '1');
    if (state.signs.length) q.set('sg', state.signs.join('.'));
    const x = ['hose', 'wfh', 'septic'].filter(k => state[k]).concat(state.extraHeads ? ['heads'] : []);
    if (x.length) q.set('x', x.join('.'));
    if (kept()) q.set(state.unit === 'gpg' ? 'kg' : 'km', '1');
    return q.toString();
  }
  // the reverse, into the form and `state`; returns {any, gpgOnly} (gpgOnly: the legacy ?gpg= link and nothing else)
  function decodeState(q) {
    let any = false, gpgOnly = false;
    Object.keys(PARAMS).forEach(k => {
      const v = q.get(PARAMS[k]);
      if (v == null || v === '') return;
      any = true;
      if (k === 'hardness' || k === 'unit' || numberFields.includes(k) || k === 'people') { if (form.elements[k]) form.elements[k].value = v; }
      else if (k === 'baths') state.baths = Math.min(6, Math.max(1, parseInt(v, 10) || 2));
      else if (k === 'choice') state.choice = v;
      else state[k] = v;
    });
    if (q.get('est') === '1') { state.useEstimate = true; state.hardSource = 'assumed'; any = true; }
    else if (q.get('h')) state.hardSource = 'measured';
    if (q.get('gpg') && !q.get('h')) { form.elements.hardness.value = q.get('gpg'); state.hardSource = 'measured'; any = true; gpgOnly = true; }
    if (q.get('sg')) state.signs = q.get('sg').split('.').filter(Boolean);
    if (q.get('x')) q.get('x').split('.').forEach(k => { if (k === 'heads') state.extraHeads = 1; else if (['hose', 'wfh', 'septic'].includes(k)) state[k] = true; });
    readForm();
    if (q.get('kg') === '1' && state.unit === 'gpg' && state.hardness) keptGpg = String(state.hardness);
    if (q.get('km') === '1' && state.unit === 'mgl' && state.hardness) keptMgl = String(state.hardness);
    reflect();
    if (more && moreHasValues()) more.open = true;
    return {any, gpgOnly};
  }
  // state into the controls (page load and Start over: no animation)
  function reflect() {
    $$('[data-cqss-seg]').forEach(g => setPressed(g, state[g.dataset.cqssSeg]));
    setPressed(pref, state.preference);
    $$('[data-cqss-flag]').forEach(ch => ch.setAttribute('aria-pressed', String(ch.dataset.cqssFlag === 'extraHeads' ? !!state.extraHeads : !!state[ch.dataset.cqssFlag])));
    $$('[data-cqss-sign]').forEach(ch => ch.setAttribute('aria-pressed', String(state.signs.includes(ch.dataset.cqssSign))));
  }
  const moreHasValues = () => ['iron', 'manganese', 'ph', 'nitrate', 'tds', 'alkalinity', 'billGallons', 'pumpGpm'].some(k => form.elements[k] && form.elements[k].value) ||
    state.signs.length > 0 || state.usePreset !== 'typical' || state.regenerant !== 'salt' || !!state.septic;
  function readUrl() {
    try { return decodeState(new URL(location.href).searchParams); } catch (_) { return {any: false, gpgOnly: false}; }
  }
  /* The address bar follows a shown result, throttled to once every 400 ms, trailing (G4 11.3: Safari allows about
     100 replaceState calls in 30 s and v2.1 wrote one per keystroke). writeUrlNow() flushes at once (reveal, share). */
  let urlTimer = 0, urlLast = 0;
  function writeUrlNow(dropGpg) {
    clearTimeout(urlTimer); urlTimer = 0; urlLast = Date.now();
    try {
      const u = new URL(location.href);
      RESULT_KEYS.forEach(k => u.searchParams.delete(k));
      if (dropGpg) u.searchParams.delete('gpg');
      if (result && result.ready) {
        u.searchParams.delete('gpg');
        new URLSearchParams(encodeState()).forEach((v, k) => u.searchParams.set(k, v));
      }
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (_) { /* old browsers keep a plain URL */ }
  }
  function writeUrl() {
    if (urlTimer) return;
    urlTimer = later(() => writeUrlNow(), Math.max(0, 400 - (Date.now() - urlLast)));
  }
  root.addEventListener('click', async e => {
    const b = e.target.closest('[data-cqss-share]');
    if (!b) return;
    writeUrlNow();
    const url = location.href;
    let ok = false;
    try { if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) { await navigator.share({title: 'My water softener size', url}); ok = true; } } catch (_) { /* cancelled */ }
    if (!ok) { try { await navigator.clipboard.writeText(url); ok = true; } catch (_) { ok = false; } }
    setText(b, ok ? 'Link copied' : 'Copy the address bar');
    track('cq_quiz_share', {outcome: result && result.pick});
    setTimeout(() => { setText(b, 'Share'); }, 2400);
  });

  /* ------------------------------------------------------------------ phone result bar visibility */
  const resultEl = $('[data-cqss-result]');
  // the result card sticks beside the calculator only while it fits the screen; taller (short laptops, long notes) it
  // scrolls with the page so Add to cart is always reachable
  const fitSticky = () => { if (resultEl) resultEl.classList.toggle('is-tall', resultEl.getBoundingClientRect().height > window.innerHeight - 100); };
  if (resultEl && 'ResizeObserver' in window) new ResizeObserver(fitSticky).observe(resultEl);
  window.addEventListener('resize', fitSticky);
  let resultVisible = true;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => { entries.forEach(en => { resultVisible = en.isIntersecting; syncDock(); }); }, {threshold: 0.05}).observe(resultEl);
  }
  function syncDock() {
    if (!dock) return;
    const show = !guide.on() && result && result.ready && !resultVisible && window.innerWidth <= 820 && !document.querySelector('dialog[open]');
    dock.classList.toggle('is-in', !!show);
    document.documentElement.classList.toggle('cqss-dock-in', !!show);
    dock.setAttribute('aria-hidden', String(!show));
    const btn = dock.querySelector('button'); if (btn) btn.tabIndex = show ? 0 : -1;
  }
  function scrollToResult() {
    const top = resultEl.getBoundingClientRect().top + window.scrollY - 88;
    window.scrollTo({top, behavior: calm() ? 'auto' : 'smooth'});
  }

  /* ------------------------------------------------------------------ specialist dialog */
  const dlg = $('[data-cqss-contact]');
  function summary() {
    if (!result || !result.ready) return '';
    const c = chosen(result), s = c.size;
    const lines = [
      'Water softener size calculator result',
      'Hardness: ' + fmt1(result.water.gpg) + ' gpg (' + (result.water.source === 'assumed' ? 'assumed' : result.water.source === 'zip' ? 'area utility figure' : 'entered') + ')' + (result.water.comp !== result.water.gpg ? ', sized for ' + fmt1(result.water.comp) + ' gpg' : ''),
      'Household: ' + result.demand.people + ' people, ' + result.flow.baths + ' full bathrooms (' + result.flow.style + '), about ' + fmt(result.demand.gallons) + ' gallons a day',
      'Peak flow: ' + fmt1(result.flow.peak) + ' GPM. Daily grains: ' + fmt(result.demand.grainsDay),
      'Size: ' + sizeName(s) + (c.item ? ' (' + c.item.product.title + ', ' + c.item.variant.title + ')' : '') + ', regenerates every ' + s.timer + ' days at ' + s.dose + ' lb salt per cu ft',
      'Priority: ' + ((S.PREFS[result.preference] || {}).label || result.preference) + (state.source ? '. Source: ' + state.source : '')
    ];
    const extra = ['iron', 'manganese', 'ph', 'nitrate', 'tds', 'alkalinity'].filter(k => state[k]).map(k => k + ' ' + state[k]);
    if (extra.length) lines.push('Water test: ' + extra.join(', '));
    if (state.signs.length) lines.push('Signs: ' + state.signs.join(', '));
    if (result.ahead.length) lines.push('Ahead of the softener: ' + result.ahead.join(', '));
    return lines.join('\n');
  }
  function openContact() {
    if (!dlg) return;
    const ta = dlg.querySelector('[data-cqss-summary]');
    if (ta && !ta.dataset.edited) ta.value = summary() + (summary() ? '\n\n' : '') + 'Anything else we should know: ';
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    track('cq_quiz_contact_open', {outcome: result && result.ready ? result.pick : 'none'});
    const h = dlg.querySelector('h2'); if (h) h.focus();
    syncDock();
  }
  if (dlg) {
    const ta = dlg.querySelector('[data-cqss-summary]');
    if (ta) ta.addEventListener('input', () => { ta.dataset.edited = '1'; });
    dlg.querySelector('[data-cqss-close]').addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', syncDock);
    const f = dlg.querySelector('form');
    const hs = dlg.dataset.hsPortal && dlg.dataset.hsForm;
    if (f && hs) f.addEventListener('submit', async e => {
      if (f.querySelector('[data-cqss-hp]').value) { e.preventDefault(); return; }
      e.preventDefault();
      const val = n => (f.elements[n] ? f.elements[n].value : '').trim();
      const name = val('contact[name]').split(/\s+/);
      const field = (n, v, type) => ({objectTypeId: type || '0-1', name: n, value: String(v)});
      const content = val('contact[body]') + '\n\nPage: ' + location.href.split('?')[0];
      const fields = [field('email', val('contact[email]')), field('firstname', name[0] || ''), field('lastname', name.slice(1).join(' ')), field('subject', 'Softener size calculator: specialist check', '0-5'), field('content', content, '0-5')];
      if (val('contact[phone]')) fields.push(field('phone', val('contact[phone]')));
      const err = dlg.querySelector('[data-cqss-hs-error]');
      const btn = f.querySelector('[type="submit"]');
      btn.disabled = true;
      let ok = false;
      try {
        const ctl = 'AbortController' in window ? new AbortController() : null;
        const t = setTimeout(() => ctl && ctl.abort(), 9000);
        const res = await fetch('https://' + dlg.dataset.hsHost + '/submissions/v3/integration/submit/' + encodeURIComponent(dlg.dataset.hsPortal) + '/' + encodeURIComponent(dlg.dataset.hsForm), {
          method: 'POST', headers: {'Content-Type': 'application/json'}, signal: ctl ? ctl.signal : undefined,
          body: JSON.stringify({fields, context: {pageUri: location.href.split('?')[0], pageName: document.title}})});
        clearTimeout(t);
        ok = res.ok;
      } catch (_) { ok = false; }
      btn.disabled = false;
      if (ok) {
        track('cq_quiz_hs_submit', {outcome: result && result.ready ? result.pick : 'none'});
        f.hidden = true;
        const sent = dlg.querySelector('[data-cqss-hs-sent]'); sent.hidden = false; sent.focus();
      } else {
        // HubSpot failed or was blocked: send the same details through the Shopify contact form so no message is lost
        track('cq_quiz_hs_fallback', {});
        if (err) err.hidden = true;
        HTMLFormElement.prototype.submit.call(f);
      }
    });
    // after a Shopify contact form post the page reloads: reopen the dialog with its status
    if (dlg.querySelector('[data-cqss-contact-state]')) { if (typeof dlg.showModal === 'function') dlg.showModal(); }
  }

  /* ------------------------------------------------------------------ reveal on scroll (matches the softener quiz) */
  function reveal() {
    const items = $$('[data-cqss-reveal], [data-cqss-reveal-stagger]');
    if (!items.length || calm() || !('IntersectionObserver' in window)) { items.forEach(el => el.classList.add('is-in')); return; }
    const fold = window.innerHeight;
    items.forEach(el => {
      if (el.getBoundingClientRect().top < fold) el.classList.add('is-in');    // the first view is never hidden
      if (el.hasAttribute('data-cqss-reveal-stagger')) Array.from(el.children).forEach((c, i) => c.style.setProperty('--cqss-d', Math.min(i, 5) * 60 + 'ms'));
    });
    root.classList.add('is-reveal-ready');
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), {rootMargin: '0px 0px -8% 0px'});
    items.filter(el => !el.classList.contains('is-in')).forEach(el => io.observe(el));
  }

  /* ------------------------------------------------------------------ start */
  window.addEventListener('resize', syncDock, {passive: true});
  $$('.cqss-card-media img').forEach(ground);
  // the entry (G4 11.1), one render, the thumbs, the scroll reveal, landing_view, then data-cqss-live
  guide.boot();
  }
})();
